import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { nacmeLogo } from './assets/images';
import AdminRouteGuard from './components/AdminRouteGuard';
import { ADMIN_SECTIONS } from './utils/adminPermissions';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Treemap, Cell } from 'recharts';

// Industry filter options
const INDUSTRY_OPTIONS = [
  '',  // Blank option for no filter
  'Abrasives and Nonmetallic Minerals Manufacturing',
  'Accessible Architecture and Design',
  'Accessible Hardware Manufacturing',
  'Accommodation and Food Services',
  'Accounting',
  'Administration of Justice',
  'Administrative and Support Services',
  'Advertising Services',
  'Agricultural Chemical Manufacturing',
  'Agriculture, Construction, Mining Machinery Manufacturing',
  'Air, Water, and Waste Program Management',
  'Airlines and Aviation',
  'Alternative Dispute Resolution',
  'Alternative Fuel Vehicle Manufacturing',
  'Alternative Medicine',
  'Ambulance Services',
  'Amusement Parks and Arcades',
  'Animal Feed Manufacturing',
  'Animation',
  'Animation and Post-production',
  'Animation at Post-production',
  'Apparel & Fashion',
  'Apparel Manufacturing',
  'Appliances, Electrical, and Electronics Manufacturing',
  'Architectural and Structural Metal Manufacturing',
  'Architecture and Planning',
  'Armed Forces',
  'Artificial Rubber and Synthetic Fiber Manufacturing',
  'Artists and Writers',
  'Arts & Crafts',
  'Arts and Crafts',
  'Audio and Video Equipment Manufacturing',
  'Automation Machinery Manufacturing',
  'Automotive',
  'Aviation & Aerospace',
  'Aviation and Aerospace Component Manufacturing',
  'Baked Goods Manufacturing',
  'Banking',
  'Bars, Taverns, and Nightclubs',
  'Bed-and-Breakfast, Hostel, Homestay',
  'Bed-and-Breakfasts, Hostels, Homestays',
  'Beverage Manufacturing',
  'Biomass Electric Power Generation',
  'Biotechnology',
  'Biotechnology Research',
  'Blockchain Services',
  'Blogs',
  'Boilers, Tanks, and Shipping Container Manufacturing',
  'Book Publishing',
  'Book and Periodical Publishing',
  'Breweries',
  'Broadcast Media Production and Distribution',
  'Building Construction',
  'Building Equipment Contractors',
  'Building Finishing Contractors',
  'Building Materials',
  'Building Structure and Exterior Contractors',
  'Business Consulting and Services',
  'Business Content',
  'Business Intelligence Platforms',
  'Business Supplies & Equipment',
  'Capital Markets',
  'Caterers',
  'Chemical Manufacturing',
  'Chemical Raw Materials Manufacturing',
  'Child Day Care Services',
  'Chiropractors',
  'Civic and Social Organizations',
  'Civil Engineering',
  'Claims Adjusting, Actuarial Services',
  'Clay and Refractory Products Manufacturing',
  'Climate Data and Analytics',
  'Climate Technology Product Manufacturing',
  'Coal Mining',
  'Collection Agencies',
  'Commercial Real Estate',
  'Commercial and Industrial Equipment Rental',
  'Commercial and Industrial Machinery Maintenance',
  'Commercial and Service Industry Machinery Manufacturing',
  'Communications Equipment Manufacturing',
  'Community Development and Urban Planning',
  'Community Services',
  'Computer Games',
  'Computer Hardware',
  'Computer Hardware Manufacturing',
  'Computer Networking',
  'Computer Networking Products',
  'Computer and Network Security',
  'Computers and Electronics Manufacturing',
  'Conservation Programs',
  'Construction',
  'Construction Hardware Manufacturing',
  'Consumer Electronics',
  'Consumer Goods',
  'Consumer Goods Rental',
  'Consumer Services',
  'Correctional Institutions',
  'Cosmetics',
  'Cosmetology and Barber Schools',
  'Courts of Law',
  'Credit Intermediation',
  'Custom Software Development ng IT System',
  'Cutlery and Handtool Manufacturing',
  'Dairy',
  'Dairy Product Manufacturing',
  'Dance Companies',
  'Data Infrastructure and Analytics',
  'Data Security Software Products',
  'Defense & Space',
  'Defense and Space Manufacturing',
  'Dentists',
  'Design Services',
  'Desktop Computing Software Products',
  'Digital Accessibility Services',
  'Distilleries',
  'E-Learning',
  'E-Learning Providers',
  'E-learning',
  'Economic Programs',
  'Education',
  'Education Administration Programs',
  'Education Management',
  'Electric Lighting Equipment Manufacturing',
  'Electric Power Generation',
  'Electric Power Transmission, Control, and Distribution',
  'Electrical Equipment Manufacturing',
  'Electronic and Precision Equipment Maintenance',
  'Embedded Software Products',
  'Emergency and Relief Services',
  'Engineering Services',
  'Engines and Power Transmission Equipment Manufacturing',
  'Entertainment Providers',
  'Environmental Quality Programs',
  'Environmental Services',
  'Equipment Rental Services',
  'Events Services',
  'Executive Offices',
  'Executive Search Services',
  'Fabricated Metal Products',
  'Facilities Services',
  'Family Planning Centers',
  'Farming',
  'Farming, Ranching, Forestry',
  'Fashion Accessories Manufacturing',
  'Financial Services',
  'Fine Art',
  'Fine Arts Schools',
  'Fire Protection',
  'Fisheries',
  'Flight Training',
  'Food & Beverages',
  'Food and Beverage Manufacturing',
  'Food and Beverage Retail',
  'Food and Beverage Services',
  'Footwear Manufacturing',
  'Footwear and Leather Goods Repair',
  'Forestry and Logging',
  'Fossil Fuel Electric Power Generation',
  'Freight and Package Transportation',
  'Fruit and Vegetable Preserves Manufacturing',
  'Fuel Cell Manufacturing',
  'Fundraising',
  'Furniture',
  'Furniture and Home Furnishings Manufacturing',
  'Gambling Facilities and Casinos',
  'Geothermal Electric Power Generation',
  'Glass Product Manufacturing',
  'Glass, Ceramics and Concrete Manufacturing',
  'Golf Courses and Country Clubs',
  'Government Administration',
  'Government Relations',
  'Government Relations Services',
  'Graphic Design',
  'Ground Passenger Transportation',
  'HVAC and Refrigeration Equipment Manufacturing',
  'Headhunting',
  'Health and Human Services',
  'Health, Wellness & Fitness',
  'Health, Wellness and Fitness',
  'Higher Education',
  'Highway, Street, and Bridge Construction',
  'Historical Sites',
  'Holding Companies',
  'Home Health Care Services',
  'Horticulture',
  'Hospitality',
  'Hospitals',
  'Hospitals and Health Care',
  'Hotels and Motels',
  'Household Appliance Manufacturing',
  'Household Services',
  'Household and Institutional Furniture Manufacturing',
  'Housing Programs',
  'Housing and Community Development',
  'Human Resources',
  'Human Resources Services',
  'Human resources',
  'Hydroelectric Power Generation',
  'IT Services and IT Consulting',
  'IT System Custom Software Development',
  'IT System Data Services',
  'IT System Design Services',
  'IT System Installation and Disposal',
  'IT System Operations and Maintenance',
  'IT System Testing and Evaluation',
  'IT System Training and Support',
  'Import & Export',
  'Import at Export',
  'Individual and Family Services',
  'Industrial Automation',
  'Industrial Machinery Manufacturing',
  'Industry Associations',
  'Information Services',
  'Information Technology & Services',
  'Information Technology and Services',
  'Insurance',
  'Insurance Agencies and Brokerages',
  'Insurance Carriers',
  'Insurance and Employee Benefit Funds',
  'Interior Design',
  'Interior design',
  'International Affairs',
  'International Trade and Development',
  'International Trade at Development',
  'Internet Marketplace Platforms',
  'Internet News',
  'Internet Publishing',
  'Interurban and Rural Bus Services',
  'Investment Advice',
  'Investment Banking',
  'Investment Management',
  'Janitorial Services',
  'Landscaping Services',
  'Language Schools',
  'Laundry and Drycleaning Services',
  'Law Enforcement',
  'Law Practice',
  'Leasing Non-residential Real Estate',
  'Leasing Real Estat Nonhunian',
  'Leasing Residential Real Estate',
  'Leasing ng Non-residential Real Estate',
  'Leather Product Manufacturing',
  'Legal Services',
  'Legislative Offices',
  'Leisure, Travel & Tourism',
  'Libraries',
  'Lime and Gypsum Products Manufacturing',
  'Loan Brokers',
  'Luxury Goods & Jewelry',
  'Machinery Manufacturing',
  'Magnetic and Optical Media Manufacturing',
  'Manufacturing',
  'Maritime',
  'Maritime Transportation',
  'Market Research',
  'Marketing Services',
  'Mattress and Blinds Manufacturing',
  'Measuring and Control Instrument Manufacturing',
  'Mechanical Or Industrial Engineering',
  'Mechanical or Industrial Engineering',
  'Media Production',
  'Media and Telecommunications',
  'Medical Device',
  'Medical Devices',
  'Medical Equipment Manufacturing',
  'Medical Practices',
  'Medical and Diagnostic Laboratories',
  'Mental Health Care',
  'Metal Ore Mining',
  'Metal Treatments',
  'Metal Valve, Ball, and Roller Manufacturing',
  'Metalworking Machinery Manufacturing',
  'Mga Bed-and-Breakfast, Hostel, Homestay',
  'Mga Entertainment Provider',
  'Mga Internet Marketplace Platform',
  'Mga Philanthropic Fundraising Service',
  'Military and International Affairs',
  'Mobile Computing Software Products',
  'Mobile Food Services',
  'Mobile Gaming Apps',
  'Motor Vehicle Manufacturing',
  'Motor Vehicle Parts Manufacturing',
  'Movies and Sound Recording',
  'Movies, Videos, and Sound',
  'Museums',
  'Museums, Historical Sites, and Zoos',
  'Music',
  'Musicians',
  'Nanotechnology Research',
  'Natural Gas Distribution',
  'Natural Gas Extraction',
  'Newspaper Publishing',
  'Non-profit Organization Management',
  'Non-profit Organizations',
  'Nonmetallic Mineral Mining',
  'Nonprofit Organization Management',
  'Nonresidential Building Construction',
  'Nuclear Electric Power Generation',
  'Nursing Homes and Residential Care Facilities',
  'Office Administration',
  'Office Furniture and Fixtures Manufacturing',
  'Oil Extraction',
  'Oil and Coal Product Manufacturing',
  'Oil and Gas',
  'Oil, Gas, and Mining',
  'Online Audio and Video Media',
  'Online Audio at Video Media',
  'Online Media',
  'Online and Mail Order Retail',
  'Operations Consulting',
  'Operations management consulting',
  'Optometrists',
  'Outpatient Care Centers',
  'Outsourcing & Offshoring',
  'Outsourcing and Offshoring Consulting',
  'Outsourcing/Offshoring',
  'Packaging & Containers',
  'Packaging and Containers Manufacturing',
  'Paint, Coating, and Adhesive Manufacturing',
  'Paper & Forest Products',
  'Paper and Forest Product Manufacturing',
  'Pension Funds',
  'Performing Arts and Spectator Sports',
  'Periodical Publishing',
  'Personal Care Product Manufacturing',
  'Personal Care Services',
  'Personal and Laundry Services',
  'Pet Services',
  'Pharmaceutical Manufacturing',
  'Philanthropic Fundraising Services',
  'Philanthropy',
  'Photography',
  'Physical, Occupational and Speech Therapists',
  'Physicians',
  'Pipeline Transportation',
  'Plastics Manufacturing',
  'Plastics and Rubber Product Manufacturing',
  'Political Organizations',
  'Postal Services',
  'Primary Metal Manufacturing',
  'Primary and Secondary Education',
  'Printing Services',
  'Professional Organizations',
  'Professional Services',
  'Professional Training and Coaching',
  'Program Development',
  'Public Assistance Programs',
  'Public Health',
  'Public Policy',
  'Public Policy Offices',
  'Public Relations and Communications Services',
  'Public Safety',
  'Racetracks',
  'Radio and Television Broadcasting',
  'Rail Transportation',
  'Railroad Equipment Manufacturing',
  'Ranching',
  'Ranching and Fisheries',
  'Real Estate',
  'Real Estate Agents and Brokers',
  'Real Estate and Equipment Rental Services',
  'Recreational Facilities',
  'Regenerative Design',
  'Religious Institutions',
  'Renewable Energy Equipment Manufacturing',
  'Renewable Energy Power Generation',
  'Renewable Energy Semiconductor Manufacturing',
  'Renewables & Environment',
  'Repair and Maintenance',
  'Research',
  'Research Services',
  'Residential Building Construction',
  'Restaurants',
  'Retail',
  'Retail Apparel and Fashion',
  'Retail Appliances, Electrical, and Electronic Equipment',
  'Retail Art Dealers',
  'Retail Art Supplies',
  'Retail Books and Printed News',
  'Retail Building Materials and Garden Equipment',
  'Retail Florists',
  'Retail Furniture and Home Furnishings',
  'Retail Gasoline',
  'Retail Groceries',
  'Retail Health and Personal Care Products',
  'Retail Luxury Goods and Jewelry',
  'Retail Motor Vehicles',
  'Retail Musical Instruments',
  'Retail Office Equipment',
  'Retail Office Supplies and Gifts',
  'Retail Pharmacies',
  'Retail Recyclable Materials & Used Merchandise',
  'Retail ng Online at Mail Order',
  'Reupholstery and Furniture Repair',
  'Robot Manufacturing',
  'Robotics Engineering',
  'Robotics engineering',
  'Rubber Products Manufacturing',
  'Satellite Telecommunications',
  'School and Employee Bus Services',
  'Seafood Product Manufacturing',
  'Secretarial Schools',
  'Securities and Commodity Exchanges',
  'Security Guards and Patrol Services',
  'Security Systems Services',
  'Security and Investigations',
  'Semiconductor Manufacturing',
  'Semiconductors',
  'Services for Renewable Energy',
  'Services for the Elderly and Disabled',
  'Sheet Music Publishing',
  'Shipbuilding',
  'Shuttles and Special Needs Transportation Services',
  'Sightseeing Transportation',
  'Skiing Facilities',
  'Smart Meter Manufacturing',
  'Soap and Cleaning Product Manufacturing',
  'Social Networking Platforms',
  'Software Development',
  'Solar Electric Power Generation',
  'Sound Recording',
  'Space Research and Technology',
  'Specialty Trade Contractors',
  'Spectator Sports',
  'Sporting Goods',
  'Sporting Goods Manufacturing',
  'Sports Teams and Clubs',
  'Sports and Recreation Instruction',
  'Spring and Wire Product Manufacturing',
  'Staffing and Recruiting',
  'Staffing at Recruiting',
  'Steam and Air-Conditioning Supply',
  'Strategic Management Services',
  'Subdivision of Land',
  'Sugar and Confectionery Product Manufacturing',
  'Surveying and Mapping Services',
  'Taxi and Limousine Services',
  'Technical and Vocational Training',
  'Technology, Information and Internet',
  'Technology, Information and Media',
  'Telecommunications',
  'Telecommunications Carriers',
  'Telephone Call Centers',
  'Temporary Help Services',
  'Textile Manufacturing',
  'Theater Companies',
  'Think Tanks',
  'Think tank',
  'Think tanks',
  'Tobacco',
  'Tobacco Manufacturing',
  'Translation and Localization',
  'Transportation Equipment Manufacturing',
  'Transportation Programs',
  'Transportation, Logistics, Supply Chain and Storage',
  'Transportation/Trucking/Railroad',
  'Travel Arrangements',
  'Truck Transportation',
  'Trusts and Estates',
  'Turned Products and Fastener Manufacturing',
  'Urban Transit Services',
  'Utilities',
  'Utilities Administration',
  'Utility System Construction',
  'Vehicle Repair and Maintenance',
  'Venture Capital and Private Equity Principals',
  'Veterinary',
  'Veterinary Services',
  'Vocational Rehabilitation Services',
  'Warehousing',
  'Warehousing and Storage',
  'Warehousing at Storage',
  'Waste Collection',
  'Waste Treatment and Disposal',
  'Water Supply and Irrigation Systems',
  'Water, Waste, Steam, and Air Conditioning Services',
  'Wellness and Fitness Services',
  'Wholesale',
  'Wholesale Alcoholic Beverages',
  'Wholesale Apparel and Sewing Supplies',
  'Wholesale Appliances, Electrical, and Electronics',
  'Wholesale Building Materials',
  'Wholesale Chemical and Allied Products',
  'Wholesale Computer Equipment',
  'Wholesale Drugs and Sundries',
  'Wholesale Food and Beverage',
  'Wholesale Footwear',
  'Wholesale Furniture and Home Furnishings',
  'Wholesale Hardware, Plumbing, Heating Equipment',
  'Wholesale Import and Export',
  'Wholesale Luxury Goods and Jewelry',
  'Wholesale Machinery',
  'Wholesale Metals and Minerals',
  'Wholesale Motor Vehicles and Parts',
  'Wholesale Paper Products',
  'Wholesale Petroleum and Petroleum Products',
  'Wholesale Photography Equipment and Supplies',
  'Wholesale Raw Farm Products',
  'Wholesale Recyclable Materials',
  'Wholesale ng Machinery',
  'Wind Electric Power Generation',
  'Wine & Spirits',
  'Wine at Spirits',
  'Wineries',
  'Wireless Services',
  "Women's Handbag Manufacturing",
  'Wood Product Manufacturing',
  'Writing and Editing',
  'Zoos and Botanical Gardens'
];

// Data mapping functions for Zapier webhook export
const parseLocationData = (locationsArray) => {
  if (!locationsArray || locationsArray.length === 0) {
    return { city: '', state: '', country: 'United States' };
  }

  // Find first non-"Remote" location
  const location = locationsArray.find(loc =>
    loc && loc.toLowerCase() !== 'remote'
  ) || locationsArray[0] || '';

  // Parse "City, State" format
  if (location.includes(',')) {
    const parts = location.split(',').map(part => part.trim());
    if (parts.length >= 2) {
      return {
        city: parts[0] || '',
        state: parts[1] || '',
        country: 'United States'
      };
    }
  }

  // Single location value
  return {
    city: location || '',
    state: '',
    country: 'United States'
  };
};

const parseManagerName = (fullName) => {
  if (!fullName) return { firstName: '', lastName: '' };

  const parts = fullName.trim().split(' ');
  if (parts.length >= 2) {
    return {
      firstName: parts[0],
      lastName: parts.slice(1).join(' ')
    };
  } else {
    return {
      firstName: parts[0] || '',
      lastName: ''
    };
  }
};

const AdminBusinessDevelopment = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState('manual-search');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  // Manual Search State
  const [searchConfig, setSearchConfig] = useState({
    name: '',
    description: '',
    time_range: '24h', // Apify API accepts: "1h", "24h", "7d", "6m"
    max_results: 30,
    title_search: '',
    title_exclusion_search: '',
    location_search: '',
    location_exclusion_search: '',
    description_search: '',
    description_exclusion_search: '',
    industry_filter: '',
    organization_employees_lte: '',
    organization_employees_gte: '',
    remote_only: false,
    ai_work_arrangement_filter: '',
    ai_has_salary: false,
    ai_experience_level_filter: '',
    remove_agency: true,
    // New Career Site Job Listing API filters
    ats_filter: '',
    ats_exclusion_filter: '',
    organization_search: '',
    organization_exclusion_search: '',
    domain_filter: '',
    domain_exclusion_filter: '',
    date_posted_after: '',
    ai_taxonomies_filter: '',
    ai_employment_type_filter: ''
  });

  // Search Results State
  const [searchResults, setSearchResults] = useState(null);
  const [isSearching, setIsSearching] = useState(false);
  const [searchHistory, setSearchHistory] = useState([]);
  const [isLoadingHistory, setIsLoadingHistory] = useState(false);
  const [leads, setLeads] = useState([]);
  const [isLoadingLeads, setIsLoadingLeads] = useState(false);
  const [selectedSearchId, setSelectedSearchId] = useState(null);
  const [leadsPagination, setLeadsPagination] = useState({ offset: 0, limit: 50, total: 0 });
  const [selectedLead, setSelectedLead] = useState(null);
  const [showLeadModal, setShowLeadModal] = useState(false);

  // Phase 1 Search & Filter State
  const [searchFilters, setSearchFilters] = useState({
    search: '',
    industry: '',
    minScore: '',
    maxScore: '',
    hasEmail: '',
    sortBy: 'created_at',
    sortOrder: 'desc'
  });
  const [uniqueIndustries, setUniqueIndustries] = useState([]);
  const [searchDebounceTimer, setSearchDebounceTimer] = useState(null);

  // Cost Tracking State
  const [costData, setCostData] = useState(null);

  // Analytics State
  const [analyticsData, setAnalyticsData] = useState(null);
  const [isLoadingAnalytics, setIsLoadingAnalytics] = useState(false);
  const [analyticsFilters, setAnalyticsFilters] = useState({
    date_from: '',
    date_to: '',
    search_id: '',
    industry: '',
    limit: 20
  });

  // API Token Management State
  const [apiToken, setApiToken] = useState('');
  const [isLoadingToken, setIsLoadingToken] = useState(false);
  const [isSavingToken, setIsSavingToken] = useState(false);
  const [tokenMessage, setTokenMessage] = useState('');

  // Zapier Webhook State
  const [zapierWebhookUrl, setZapierWebhookUrl] = useState('');
  const [isLoadingWebhook, setIsLoadingWebhook] = useState(false);
  const [isSavingWebhook, setIsSavingWebhook] = useState(false);
  const [webhookMessage, setWebhookMessage] = useState('');
  const [selectedLeads, setSelectedLeads] = useState(new Set());
  const [exportStatus, setExportStatus] = useState(null);
  const [isExporting, setIsExporting] = useState(false);

  // Scheduled Searches State
  const [scheduledSearches, setScheduledSearches] = useState([]);
  const [isLoadingScheduledSearches, setIsLoadingScheduledSearches] = useState(false);
  const [scheduledSearchesEnabled, setScheduledSearchesEnabled] = useState(false);
  const [isTogglingGlobal, setIsTogglingGlobal] = useState(false);

  // Sync activeTab with URL parameters
  useEffect(() => {
    const tabFromUrl = searchParams.get('tab');
    if (tabFromUrl && tabFromUrl !== activeTab) {
      setActiveTab(tabFromUrl);
    }
  }, [searchParams, activeTab]);

  // Load Zapier webhook URL from backend
  const fetchWebhookUrl = async () => {
    setIsLoadingWebhook(true);
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        console.error('No authentication token found');
        return;
      }

      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
      const response = await fetch(`${backendUrl}/api/business-development/settings/zapier_webhook_url`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        if (data.setting_value) {
          setZapierWebhookUrl(data.setting_value);
        }
      }
    } catch (err) {
      console.error('Error loading webhook URL:', err);
    } finally {
      setIsLoadingWebhook(false);
    }
  };

  useEffect(() => {
    fetchWebhookUrl();
  }, []);

  // Load data based on active tab
  useEffect(() => {
    if (activeTab === 'cost-tracking') {
      fetchCostTracking();
    } else if (activeTab === 'api-settings') {
      fetchApiToken();
    } else if (activeTab === 'analytics') {
      fetchAnalyticsData();
      fetchSearchHistory(); // Load search history for the dropdown
    } else if (activeTab === 'search-history') {
      fetchSearchHistory();
    } else if (activeTab === 'scheduled-searches') {
      fetchScheduledSearches();
      fetchScheduledSearchesEnabled();
    }
  }, [activeTab]);

  const fetchCostTracking = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        navigate('/admin');
        return;
      }

      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
      const response = await fetch(`${backendUrl}/api/business-development/cost-tracking`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch cost data');
      }

      const data = await response.json();
      setCostData(data);
    } catch (err) {
      console.error('Error fetching cost data:', err);
      setError('Failed to load cost tracking data');
    }
  };

  const fetchApiToken = async () => {
    setIsLoadingToken(true);
    setTokenMessage('');

    try {
      const token = localStorage.getItem('token');
      if (!token) {
        navigate('/admin');
        return;
      }

      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
      const response = await fetch(`${backendUrl}/api/business-development/settings/apify_api_token`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setApiToken(data.setting_value || '');
      } else if (response.status === 404) {
        // Token not set yet, this is normal
        setApiToken('');
      } else {
        throw new Error('Failed to fetch API token');
      }
    } catch (err) {
      console.error('Error fetching API token:', err);
      setTokenMessage('Failed to load API token configuration');
    } finally {
      setIsLoadingToken(false);
    }
  };

  const saveApiToken = async () => {
    setIsSavingToken(true);
    setTokenMessage('');

    try {
      const token = localStorage.getItem('token');
      if (!token) {
        navigate('/admin');
        return;
      }

      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
      const response = await fetch(`${backendUrl}/api/business-development/settings/apify_api_token`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ value: apiToken })
      });

      if (response.ok) {
        setTokenMessage('API token saved successfully! You can now run hiring manager searches.');
        setSuccessMessage('Apify API token configured successfully.');
      } else {
        const errorData = await response.text();
        throw new Error(errorData || 'Failed to save API token');
      }
    } catch (err) {
      console.error('Error saving API token:', err);
      setTokenMessage(`Failed to save API token: ${err.message}`);
      setError('Failed to save API token configuration');
    } finally {
      setIsSavingToken(false);
    }
  };

  // Save Zapier webhook URL to backend
  const saveWebhookUrl = async () => {
    setIsSavingWebhook(true);
    setWebhookMessage('');
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        navigate('/admin');
        return;
      }

      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
      const response = await fetch(`${backendUrl}/api/business-development/settings/zapier_webhook_url`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ value: zapierWebhookUrl })
      });

      if (response.ok) {
        setWebhookMessage('Webhook URL saved successfully!');
        setSuccessMessage('Zapier webhook URL configured successfully.');
      } else {
        const errorData = await response.text();
        throw new Error(errorData || 'Failed to save webhook URL');
      }
    } catch (err) {
      console.error('Error saving webhook URL:', err);
      setWebhookMessage(`Failed to save webhook URL: ${err.message}`);
      setError('Failed to save webhook URL configuration');
    } finally {
      setIsSavingWebhook(false);
    }
  };

  // Export function for Zapier/HubSpot integration
  const exportSelectedLeads = async () => {
    // Step 1: Validation checks
    if (!zapierWebhookUrl.trim()) {
      setExportStatus({
        type: 'error',
        message: 'Please configure your Zapier webhook URL first',
        progress: 0
      });
      return;
    }

    if (selectedLeads.size === 0) {
      setExportStatus({
        type: 'error',
        message: 'Please select at least one lead to export',
        progress: 0
      });
      return;
    }

    // Step 2: Set loading state
    setIsExporting(true);
    setExportStatus({
      type: 'progress',
      message: 'Preparing export data...',
      progress: 20
    });

    try {
      // Step 3: Get selected lead data
      const selectedLeadData = leads.filter(lead => selectedLeads.has(lead.id));

      // Step 4: Process and map data
      setExportStatus({
        type: 'progress',
        message: `Processing ${selectedLeadData.length} leads...`,
        progress: 40
      });

      const webhookData = selectedLeadData.map(lead => {
        const location = parseLocationData(lead.locations_derived);
        const hiringManagerName = lead.ai_hiring_manager_name || lead.li_hiring_manager_name || '';
        const name = parseManagerName(hiringManagerName);

        return {
          'id': lead.id,  // Include original lead ID for tracking
          'First Name': name.firstName,
          'Last Name': name.lastName,
          'Email': lead.ai_hiring_manager_email_address || '',
          'Company Name': lead.organization || '',
          'LinkedIn URL': lead.li_hiring_manager_url || '',
          'City': location.city,
          'State/Region Code': location.state,
          'Country/Region': location.country
        };
      });

      // Step 5: Send leads individually to Zapier
      setExportStatus({
        type: 'progress',
        message: 'Sending to HubSpot via Zapier...',
        progress: 70
      });

      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
      let successCount = 0;
      let failCount = 0;

      // Send each lead as a separate webhook call
      for (let i = 0; i < webhookData.length; i++) {
        const lead = webhookData[i];

        // Update progress for each lead
        const progressPercent = 70 + ((i + 1) / webhookData.length) * 25;
        setExportStatus({
          type: 'progress',
          message: `Sending lead ${i + 1} of ${webhookData.length} to HubSpot...`,
          progress: Math.round(progressPercent)
        });

        try {
          const response = await fetch(`${backendUrl}/api/admin/business-development/export-to-zapier`, {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('token')}`,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              webhook_url: zapierWebhookUrl,
              leads_data: lead  // Send individual lead object
            })
          });

          if (response.ok) {
            successCount++;
          } else {
            failCount++;
            console.error(`Failed to send lead ${i + 1}:`, response.status);
          }
        } catch (error) {
          failCount++;
          console.error(`Error sending lead ${i + 1}:`, error);
        }

        // Small delay between requests to avoid overwhelming Zapier
        await new Promise(resolve => setTimeout(resolve, 200));
      }

      // Step 6: Handle final results
      if (successCount === webhookData.length) {
        setExportStatus({
          type: 'success',
          message: `Successfully exported all ${successCount} leads to HubSpot!`,
          progress: 100
        });
      } else if (successCount > 0) {
        setExportStatus({
          type: 'warning',
          message: `Exported ${successCount} of ${webhookData.length} leads. ${failCount} failed.`,
          progress: 100
        });
      } else {
        throw new Error('Failed to export any leads');
      }

      setSelectedLeads(new Set()); // Clear selection
      // Auto-hide message after 5 seconds
      setTimeout(() => setExportStatus(null), 5000);
    } catch (error) {
      setExportStatus({
        type: 'error',
        message: `Export failed: ${error.message}`,
        progress: 0
      });

      // Auto-hide error message after 8 seconds
      setTimeout(() => setExportStatus(null), 8000);
    } finally {
      setIsExporting(false);
    }
  };

  const fetchSearchHistory = async () => {
    setIsLoadingHistory(true);
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        navigate('/admin');
        return;
      }

      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
      const response = await fetch(`${backendUrl}/api/business-development/search-history`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch search history');
      }

      const data = await response.json();
      setSearchHistory(data.searches);
    } catch (err) {
      console.error('Error fetching search history:', err);
      setError(`Failed to load search history: ${err.message}`);
    } finally {
      setIsLoadingHistory(false);
    }
  };

  const fetchUniqueIndustries = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return;

      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
      const response = await fetch(`${backendUrl}/api/business-development/industries`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setUniqueIndustries(data.industries);
      }
    } catch (err) {
      console.error('Error fetching industries:', err);
    }
  };

  const fetchLeads = async (searchId = null, offset = 0, filters = searchFilters) => {
    setIsLoadingLeads(true);
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        navigate('/admin');
        return;
      }

      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
      const params = new URLSearchParams();

      // Add pagination
      params.append('limit', leadsPagination.limit);
      params.append('offset', offset);

      // Add search ID if provided
      if (searchId) {
        params.append('search_id', searchId);
      }

      // Add search and filter parameters
      if (filters.search) {
        params.append('search', filters.search);
      }
      if (filters.industry) {
        params.append('industry', filters.industry);
      }
      if (filters.minScore) {
        params.append('min_score', filters.minScore);
      }
      if (filters.maxScore) {
        params.append('max_score', filters.maxScore);
      }
      if (filters.hasEmail !== '') {
        params.append('has_email', filters.hasEmail);
      }
      if (filters.sortBy) {
        params.append('sort_by', filters.sortBy);
      }
      if (filters.sortOrder) {
        params.append('sort_order', filters.sortOrder);
      }

      const url = `${backendUrl}/api/business-development/leads?${params.toString()}`;
      const response = await fetch(url, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch leads');
      }

      const data = await response.json();
      setLeads(data.leads);
      setLeadsPagination({
        offset: data.offset,
        limit: data.limit,
        total: data.total_count
      });
    } catch (err) {
      console.error('Error fetching leads:', err);
      setError(`Failed to load leads: ${err.message}`);
    } finally {
      setIsLoadingLeads(false);
    }
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setSearchParams({ tab });
    setError('');
    setSuccessMessage('');

    // Load data when switching to specific tabs
    if (tab === 'search-history') {
      fetchSearchHistory();
      fetchLeads();
      fetchUniqueIndustries();
    }
  };

  const handleInputChange = (field, value) => {
    setSearchConfig(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleArrayFieldChange = (field, value) => {
    // Store as string, convert to array only when submitting
    setSearchConfig(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleFilterChange = (field, value) => {
    setSearchFilters(prev => ({
      ...prev,
      [field]: value
    }));

    // Debounce search input
    if (field === 'search') {
      if (searchDebounceTimer) {
        clearTimeout(searchDebounceTimer);
      }
      const timer = setTimeout(() => {
        fetchLeads(selectedSearchId, 0, { ...searchFilters, [field]: value });
      }, 300); // 300ms delay
      setSearchDebounceTimer(timer);
    } else {
      // Apply other filters immediately
      fetchLeads(selectedSearchId, 0, { ...searchFilters, [field]: value });
    }
  };

  const handleSortChange = (sortBy) => {
    let newSortOrder = 'desc';
    if (searchFilters.sortBy === sortBy) {
      // Toggle sort order if clicking same column
      newSortOrder = searchFilters.sortOrder === 'desc' ? 'asc' : 'desc';
    }
    const newFilters = {
      ...searchFilters,
      sortBy,
      sortOrder: newSortOrder
    };
    setSearchFilters(newFilters);
    fetchLeads(selectedSearchId, 0, newFilters);
  };

  const clearFilters = () => {
    const clearedFilters = {
      search: '',
      industry: '',
      minScore: '',
      maxScore: '',
      hasEmail: '',
      sortBy: 'created_at',
      sortOrder: 'desc'
    };
    setSearchFilters(clearedFilters);
    fetchLeads(selectedSearchId, 0, clearedFilters);
  };

  const pollForResults = async (runId, token, backendUrl) => {
    const maxAttempts = 30; // Maximum 5 minutes (30 attempts * 10 seconds)
    let attempts = 0;

    while (attempts < maxAttempts) {
      try {
        const response = await fetch(`${backendUrl}/api/business-development/search-runs/${runId}`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (!response.ok) {
          throw new Error('Failed to fetch results');
        }

        const data = await response.json();

        if (data.status === 'completed') {
          setSearchResults(data);
          setSuccessMessage(`Search completed successfully! Found ${data.new_leads_added || 0} new leads (${data.leads_found || 0} total processed, ${data.duplicate_leads_skipped || 0} duplicates skipped).`);
          return;
        } else if (data.status === 'failed') {
          setError(`Search failed: ${data.error_message || 'Unknown error'}`);
          return;
        }

        // Status is still 'running', wait and try again
        attempts++;
        setSuccessMessage(`Search in progress... (${attempts * 10}s elapsed)`);
        await new Promise(resolve => setTimeout(resolve, 10000)); // Wait 10 seconds

      } catch (error) {
        console.error('Error polling for results:', error);
        setError(`Error checking search status: ${error.message}`);
        return;
      }
    }

    // Timeout reached
    setError('Search is taking longer than expected. Please check the search history for results.');
  };

  const runManualSearch = async () => {
    setIsSearching(true);
    setError('');
    setSuccessMessage('');

    try {
      const token = localStorage.getItem('token');
      if (!token) {
        navigate('/admin');
        return;
      }

      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';

      // Transform frontend config to match backend Pydantic model
      const splitCSV = (val) => val ? val.split(',').map(item => item.trim()).filter(item => item) : null;

      const backendConfig = {
        search_name: searchConfig.name,
        search_type: searchConfig.schedule_type || 'manual',
        time_range: searchConfig.time_range,
        max_results: parseInt(searchConfig.max_results) || 50,
        remove_agency: searchConfig.remove_agency,
        title_search: splitCSV(searchConfig.title_search),
        title_exclusion_search: splitCSV(searchConfig.title_exclusion_search),
        location_search: splitCSV(searchConfig.location_search),
        location_exclusion_search: splitCSV(searchConfig.location_exclusion_search),
        description_search: splitCSV(searchConfig.description_search),
        description_exclusion_search: splitCSV(searchConfig.description_exclusion_search),
        industry_filter: searchConfig.industry_filter ? [searchConfig.industry_filter] : null,
        organization_employees_lte: searchConfig.organization_employees_lte ? parseInt(searchConfig.organization_employees_lte) : null,
        organization_employees_gte: searchConfig.organization_employees_gte ? parseInt(searchConfig.organization_employees_gte) : null,
        remote_only: searchConfig.remote_only,
        ai_work_arrangement_filter: searchConfig.ai_work_arrangement_filter ? [searchConfig.ai_work_arrangement_filter] : null,
        ai_has_salary: searchConfig.ai_has_salary === true || searchConfig.ai_has_salary === 'true',
        ai_experience_level_filter: searchConfig.ai_experience_level_filter ? [searchConfig.ai_experience_level_filter] : null,
        ai_visa_sponsorship_filter: false,
        // New Career Site Job Listing API filters
        ats_filter: splitCSV(searchConfig.ats_filter),
        ats_exclusion_filter: splitCSV(searchConfig.ats_exclusion_filter),
        organization_search: splitCSV(searchConfig.organization_search),
        organization_exclusion_search: splitCSV(searchConfig.organization_exclusion_search),
        domain_filter: splitCSV(searchConfig.domain_filter),
        domain_exclusion_filter: splitCSV(searchConfig.domain_exclusion_filter),
        date_posted_after: searchConfig.date_posted_after || null,
        ai_taxonomies_filter: splitCSV(searchConfig.ai_taxonomies_filter),
        ai_employment_type_filter: splitCSV(searchConfig.ai_employment_type_filter),
        // Scheduling fields
        schedule_type: searchConfig.schedule_type || null,
        schedule_time: searchConfig.schedule_time || null,
        schedule_days_of_week: searchConfig.schedule_days_of_week || null
      };

      // Debug logging
      console.log('Frontend searchConfig:', searchConfig);
      console.log('Transformed backendConfig:', backendConfig);

      // First create the search configuration
      const createResponse = await fetch(`${backendUrl}/api/business-development/searches`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(backendConfig)
      });

      if (!createResponse.ok) {
        throw new Error('Failed to create search configuration');
      }

      const searchData = await createResponse.json();

      // Only run immediately if it's not scheduled
      if (!searchConfig.schedule_type) {
        // Then run the search
        const runResponse = await fetch(`${backendUrl}/api/business-development/searches/${searchData.id}/run`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (!runResponse.ok) {
          throw new Error('Failed to execute search');
        }

        const runData = await runResponse.json();

        // Show initial loading message
        setSuccessMessage('Search started successfully! Fetching results...');

        // Poll for results
        await pollForResults(runData.run_id, token, backendUrl);
      } else {
        // For scheduled searches, just show success message
        setSuccessMessage(`Scheduled search "${searchConfig.name}" created successfully! It will run ${searchConfig.schedule_type} at ${searchConfig.schedule_time || '09:00'} UTC.`);

        // Clear the form
        setSearchConfig({
          name: '',
          description: '',
          max_results: 50,
          time_range: '24h',
          contact_type: 'email',
          title_search: '',
          title_exclusion_search: '',
          location_search: '',
          location_exclusion_search: '',
          description_search: '',
          description_exclusion_search: '',
          industry_filter: '',
          organization_employees_gte: '',
          organization_employees_lte: '',
          remote_only: false,
          remove_agency: false,
          exclude_non_management_recruiters: false,
          ai_work_arrangement_filter: '',
          ai_has_salary: false,
          ai_experience_level_filter: '',
          ai_visa_sponsorship_filter: false,
          schedule_type: '',
          schedule_time: '09:00',
          schedule_days_of_week: []
        });
      }

    } catch (err) {
      console.error('Error running search:', err);
      setError(`Search failed: ${err.message}`);
    } finally {
      setIsSearching(false);
    }
  };

  const renderManualSearch = () => (
    <div className="space-y-6">
      <div className="bg-white p-6 rounded-lg shadow-md">
        <h3 className="text-xl font-semibold mb-4">Configure Hiring Manager Search</h3>

        {/* Basic Configuration */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Search Name *
            </label>
            <input
              type="text"
              value={searchConfig.name}
              onChange={(e) => handleInputChange('name', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
              placeholder="e.g., Tech Companies Bay Area"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Max Results
            </label>
            <input
              type="number"
              value={searchConfig.max_results}
              onChange={(e) => handleInputChange('max_results', parseInt(e.target.value))}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
              min="1"
              max="1000"
            />
          </div>
        </div>

        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Description
          </label>
          <textarea
            value={searchConfig.description}
            onChange={(e) => handleInputChange('description', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
            rows="3"
            placeholder="Describe this search configuration..."
          />
        </div>

        {/* Time Range */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Time Range
            </label>
            <select
              value={searchConfig.time_range}
              onChange={(e) => handleInputChange('time_range', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
            >
              <option value="1h">Last 1 hour</option>
              <option value="24h">Last 24 hours</option>
              <option value="7d">Last 7 days</option>
              <option value="6m">Last 6 months (backfill)</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Date Posted After
            </label>
            <input
              type="date"
              value={searchConfig.date_posted_after}
              onChange={(e) => handleInputChange('date_posted_after', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
            />
            <p className="text-xs text-gray-500 mt-1">Only show jobs posted after this date</p>
          </div>
        </div>

        {/* Search Filters */}
        <div className="space-y-4 mb-6">
          <h4 className="text-lg font-medium text-gray-800">Search Filters</h4>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Job Titles (comma-separated)
              </label>
              <input
                type="text"
                value={searchConfig.title_search}
                onChange={(e) => handleArrayFieldChange('title_search', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
                placeholder="Software Engineer, Data Scientist"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Exclude Titles (comma-separated)
              </label>
              <input
                type="text"
                value={searchConfig.title_exclusion_search}
                onChange={(e) => handleArrayFieldChange('title_exclusion_search', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
                placeholder="Intern, Junior"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Locations (comma-separated)
              </label>
              <input
                type="text"
                value={searchConfig.location_search}
                onChange={(e) => handleArrayFieldChange('location_search', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
                placeholder="San Francisco, New York, Remote"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Industry Filter
              </label>
              <select
                value={searchConfig.industry_filter}
                onChange={(e) => handleInputChange('industry_filter', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md bg-white"
              >
                <option value="">All Industries (No Filter)</option>
                {INDUSTRY_OPTIONS.slice(1).map((industry) => (
                  <option key={industry} value={industry}>
                    {industry}
                  </option>
                ))}
              </select>
              <p className="text-xs text-gray-500 mt-1">
                Select a specific industry or leave blank to search all industries
              </p>
            </div>
          </div>
        </div>

        {/* Company Size Filters */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Min Company Size (employees)
            </label>
            <input
              type="number"
              value={searchConfig.organization_employees_gte}
              onChange={(e) => handleInputChange('organization_employees_gte', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
              placeholder="50"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Max Company Size (employees)
            </label>
            <input
              type="number"
              value={searchConfig.organization_employees_lte}
              onChange={(e) => handleInputChange('organization_employees_lte', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
              placeholder="5000"
            />
          </div>
        </div>

        {/* Company & Domain Filters */}
        <div className="space-y-4 mb-6">
          <h4 className="text-lg font-medium text-gray-800">Company & Domain Filters</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Company Names (comma-separated)
              </label>
              <input
                type="text"
                value={searchConfig.organization_search}
                onChange={(e) => handleArrayFieldChange('organization_search', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
                placeholder="Google, Microsoft, Amazon"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Exclude Companies (comma-separated)
              </label>
              <input
                type="text"
                value={searchConfig.organization_exclusion_search}
                onChange={(e) => handleArrayFieldChange('organization_exclusion_search', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
                placeholder="Staffing Corp, Temp Agency"
              />
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Company Domains (comma-separated)
              </label>
              <input
                type="text"
                value={searchConfig.domain_filter}
                onChange={(e) => handleArrayFieldChange('domain_filter', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
                placeholder="google.com, microsoft.com"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Exclude Domains (comma-separated)
              </label>
              <input
                type="text"
                value={searchConfig.domain_exclusion_filter}
                onChange={(e) => handleArrayFieldChange('domain_exclusion_filter', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
                placeholder="staffing.com"
              />
            </div>
          </div>
        </div>

        {/* ATS Platform Filter */}
        <div className="space-y-4 mb-6">
          <h4 className="text-lg font-medium text-gray-800">ATS Platform Filter</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                ATS Platforms (comma-separated)
              </label>
              <input
                type="text"
                value={searchConfig.ats_filter}
                onChange={(e) => handleArrayFieldChange('ats_filter', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
                placeholder="Workday, Greenhouse, Lever, Ashby"
              />
              <p className="text-xs text-gray-500 mt-1">54 ATS platforms supported: Workday, Greenhouse, Ashby, Lever, Rippling, iCIMS, SuccessFactors, etc.</p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Exclude ATS Platforms (comma-separated)
              </label>
              <input
                type="text"
                value={searchConfig.ats_exclusion_filter}
                onChange={(e) => handleArrayFieldChange('ats_exclusion_filter', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
                placeholder="SmartRecruiters"
              />
            </div>
          </div>
        </div>

        {/* AI Classification Filters */}
        <div className="space-y-4 mb-6">
          <h4 className="text-lg font-medium text-gray-800">AI Classification Filters</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Job Categories (comma-separated)
              </label>
              <input
                type="text"
                value={searchConfig.ai_taxonomies_filter}
                onChange={(e) => handleArrayFieldChange('ai_taxonomies_filter', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
                placeholder="Engineering, Data Science, Product Management"
              />
              <p className="text-xs text-gray-500 mt-1">33 categories: Engineering, Data Science, Product Management, Design, Marketing, Sales, Finance, HR, Legal, etc.</p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Employment Type (comma-separated)
              </label>
              <input
                type="text"
                value={searchConfig.ai_employment_type_filter}
                onChange={(e) => handleArrayFieldChange('ai_employment_type_filter', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
                placeholder="Full-time, Contract"
              />
            </div>
          </div>
        </div>

        {/* Checkboxes */}
        <div className="flex flex-wrap gap-6 mb-6">
          <label className="flex items-center">
            <input
              type="checkbox"
              checked={searchConfig.remote_only}
              onChange={(e) => handleInputChange('remote_only', e.target.checked)}
              className="mr-2"
            />
            Remote jobs only
          </label>

          <label className="flex items-center">
            <input
              type="checkbox"
              checked={searchConfig.remove_agency}
              onChange={(e) => handleInputChange('remove_agency', e.target.checked)}
              className="mr-2"
            />
            Remove recruitment agencies
          </label>
        </div>

        {/* Scheduling Options */}
        <div className="border-t pt-6 mb-6">
          <h4 className="text-lg font-medium text-gray-800 mb-4">Scheduling Options (Optional)</h4>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Schedule Type
              </label>
              <select
                value={searchConfig.schedule_type || ''}
                onChange={(e) => handleInputChange('schedule_type', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
              >
                <option value="">Run Once (Manual)</option>
                <option value="daily">Daily</option>
                <option value="weekly">Weekly</option>
              </select>
            </div>

            {searchConfig.schedule_type && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Schedule Time (UTC)
                </label>
                <input
                  type="time"
                  value={searchConfig.schedule_time || '09:00'}
                  onChange={(e) => handleInputChange('schedule_time', e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md"
                />
              </div>
            )}

            {searchConfig.schedule_type === 'weekly' && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Days of Week
                </label>
                <select
                  multiple
                  value={searchConfig.schedule_days_of_week || []}
                  onChange={(e) => {
                    const values = Array.from(e.target.selectedOptions, option => parseInt(option.value));
                    handleInputChange('schedule_days_of_week', values);
                  }}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md"
                  size="4"
                >
                  <option value="1">Monday</option>
                  <option value="2">Tuesday</option>
                  <option value="3">Wednesday</option>
                  <option value="4">Thursday</option>
                  <option value="5">Friday</option>
                  <option value="6">Saturday</option>
                  <option value="0">Sunday</option>
                </select>
                <p className="text-xs text-gray-500 mt-1">Hold Ctrl/Cmd to select multiple days</p>
              </div>
            )}
          </div>

          {searchConfig.schedule_type && (
            <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-md">
              <p className="text-sm text-blue-800">
                <strong>Note:</strong> Scheduled searches will run automatically at 6 AM UTC daily when enabled.
                The schedule type determines how often the search repeats.
              </p>
            </div>
          )}
        </div>

        {/* Run Search Button */}
        <div className="flex justify-end">
          <button
            onClick={runManualSearch}
            disabled={isSearching || !searchConfig.name}
            className="bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 text-white px-6 py-2 rounded-md font-medium"
          >
            {isSearching ? (searchConfig.schedule_type ? 'Creating Scheduled Search...' : 'Searching...') :
             (searchConfig.schedule_type ? 'Create Scheduled Search' : 'Run Search')}
          </button>
        </div>

        {/* Search Results */}
        {searchResults && (
          <div className="mt-6 p-4 bg-gray-50 rounded-md">
            <h4 className="text-lg font-medium mb-2">Search Results</h4>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
              <div>
                <span className="font-medium">Status:</span> {searchResults.status}
              </div>
              <div>
                <span className="font-medium">Leads Found:</span> {searchResults.leads_found || 0}
              </div>
              <div>
                <span className="font-medium">New Leads:</span> {searchResults.new_leads_added || 0}
              </div>
              <div>
                <span className="font-medium">Cost:</span> ${searchResults.apify_cost_usd || 0}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );

  const renderCostTracking = () => (
    <div className="space-y-6">
      <div className="bg-white p-6 rounded-lg shadow-md">
        <h3 className="text-xl font-semibold mb-4">Cost Tracking - Last 30 Days</h3>

        {costData ? (
          <div className="space-y-6">
            {/* Summary Cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="bg-blue-50 p-4 rounded-lg">
                <div className="text-sm text-blue-600 font-medium">Total Leads</div>
                <div className="text-2xl font-bold text-blue-800">{costData.leads_last_30_days}</div>
              </div>

              <div className="bg-green-50 p-4 rounded-lg">
                <div className="text-sm text-green-600 font-medium">Estimated Cost</div>
                <div className="text-2xl font-bold text-green-800">${costData.estimated_cost_usd}</div>
              </div>
            </div>

            {/* Daily Breakdown */}
            <div>
              <h4 className="text-lg font-medium mb-4">Daily Breakdown</h4>
              <div className="overflow-x-auto">
                <table className="min-w-full bg-white border border-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">Date</th>
                      <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">Leads</th>
                      <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">Estimated</th>
                      <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">Actual</th>
                      <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">Runs</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {costData.breakdown.map((day, index) => (
                      <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                        <td className="px-4 py-2 text-sm">{day.date}</td>
                        <td className="px-4 py-2 text-sm">{day.leads}</td>
                        <td className="px-4 py-2 text-sm">${day.estimated_cost.toFixed(2)}</td>
                        <td className="px-4 py-2 text-sm">${day.actual_cost.toFixed(2)}</td>
                        <td className="px-4 py-2 text-sm">{day.runs}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Refresh Button */}
            <div className="flex justify-end">
              <button
                onClick={fetchCostTracking}
                className="bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded-md text-sm"
              >
                Refresh Data
              </button>
            </div>
          </div>
        ) : (
          <div className="text-center py-8">
            <div className="text-gray-500">Loading cost tracking data...</div>
          </div>
        )}
      </div>
    </div>
  );

  const renderApiSettings = () => (
    <div className="space-y-6">
      <div className="bg-white p-6 rounded-lg shadow-md">
        <h3 className="text-xl font-semibold mb-4">Apify API Configuration</h3>
        <p className="text-gray-600 mb-6">
          Configure your Apify API token to enable hiring manager searches. You can get your token from the
          <a href="https://console.apify.com/settings/integrations" target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:text-blue-600 ml-1">
            Apify Console
          </a>.
        </p>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Apify API Token *
            </label>
            <input
              type="password"
              value={apiToken}
              onChange={(e) => setApiToken(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="apify_api_xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx"
              disabled={isLoadingToken}
            />
            <p className="text-xs text-gray-500 mt-1">
              Your token is encrypted and stored securely. It's only used to make API calls to Apify.
            </p>
          </div>

          {tokenMessage && (
            <div className={`text-sm p-3 rounded-md ${
              tokenMessage.includes('successfully')
                ? 'bg-green-100 text-green-700 border border-green-200'
                : 'bg-red-100 text-red-700 border border-red-200'
            }`}>
              {tokenMessage}
            </div>
          )}

          <div className="flex justify-between items-center pt-4">
            <div className="text-sm text-gray-500">
              <strong>Cost:</strong> $25 per 1,000 leads ($0.025 each)
            </div>

            <div className="flex space-x-3">
              <button
                onClick={fetchApiToken}
                disabled={isLoadingToken}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md disabled:opacity-50"
              >
                {isLoadingToken ? 'Loading...' : 'Reload'}
              </button>

              <button
                onClick={saveApiToken}
                disabled={isSavingToken || isLoadingToken || !apiToken.trim()}
                className="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 rounded-md"
              >
                {isSavingToken ? 'Saving...' : 'Save Token'}
              </button>
            </div>
          </div>
        </div>

        {/* API Status */}
        <div className="mt-6 pt-6 border-t border-gray-200">
          <h4 className="text-lg font-medium mb-3">API Status</h4>
          <div className="flex items-center space-x-3">
            <div className={`w-3 h-3 rounded-full ${
              apiToken.trim() ? 'bg-green-500' : 'bg-red-500'
            }`}></div>
            <span className="text-sm">
              {apiToken.trim()
                ? 'API token configured - Ready to run searches'
                : 'API token required - Configure above to enable searches'
              }
            </span>
          </div>

          {apiToken.trim() && (
            <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-md">
              <div className="text-sm text-blue-800">
                <strong>Next Steps:</strong>
                <ol className="list-decimal list-inside mt-2 space-y-1">
                  <li>Go to the "Manual Search" tab to configure and run hiring manager searches</li>
                  <li>Monitor costs and usage in the "Cost Tracking" tab</li>
                  <li>Schedule automated searches in the "Scheduled Searches" tab (coming soon)</li>
                </ol>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Zapier Webhook Configuration */}
      <div className="bg-white p-6 rounded-lg shadow-md">
        <h3 className="text-xl font-semibold mb-4">Zapier Webhook Configuration</h3>
        <p className="text-gray-600 mb-4">
          Configure your Zapier webhook URL to enable exporting leads to HubSpot. This system supports both individual and bulk lead exports.
        </p>

        {/* Setup Instructions */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
          <h4 className="text-sm font-semibold text-blue-800 mb-2">📝 Zapier Setup Instructions</h4>
          <div className="text-sm text-blue-700 space-y-2">
            <p><strong>Step 1:</strong> Create a new Zap with "Webhooks by Zapier" → "Catch Hook" trigger</p>
            <p><strong>Step 2:</strong> Copy the webhook URL and paste it below</p>
            <p><strong>Step 3:</strong> Add "Code by Zapier" → "Run JavaScript" step for bulk processing</p>
            <p><strong>Step 4:</strong> Add "HubSpot" → "Create Contact" action</p>
            <p className="pt-2">
              <a
                href="#bulk-setup"
                className="text-blue-600 hover:text-blue-800 underline font-medium"
                onClick={(e) => {
                  e.preventDefault();
                  // Scroll to bulk setup documentation or open help modal
                  alert('For detailed bulk setup instructions, see the ZapierLeadsWebHook.md documentation in your project files.');
                }}
              >
                📖 View detailed bulk setup guide
              </a>
            </p>
          </div>
        </div>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Zapier Webhook URL
            </label>
            <div className="flex space-x-2">
              <input
                type="url"
                value={zapierWebhookUrl}
                onChange={(e) => setZapierWebhookUrl(e.target.value)}
                disabled={isLoadingWebhook}
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
                placeholder="https://hooks.zapier.com/hooks/catch/..."
              />
              <button
                onClick={saveWebhookUrl}
                disabled={isSavingWebhook || isLoadingWebhook || !zapierWebhookUrl.trim()}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed"
              >
                {isSavingWebhook ? 'Saving...' : 'Save'}
              </button>
            </div>
            <p className="text-xs text-gray-500 mt-1">
              This URL will receive lead data when you export from the search history.
            </p>
            {webhookMessage && (
              <p className={`text-sm mt-2 ${webhookMessage.includes('Failed') ? 'text-red-600' : 'text-green-600'}`}>
                {webhookMessage}
              </p>
            )}
          </div>

          <div className="flex items-center space-x-3">
            <div className={`w-3 h-3 rounded-full ${
              zapierWebhookUrl.trim() ? 'bg-green-500' : 'bg-red-500'
            }`}></div>
            <span className="text-sm">
              {isLoadingWebhook ? 'Loading...' : zapierWebhookUrl.trim() ? 'Webhook URL Configured' : 'Webhook URL Not Set'}
            </span>
          </div>

          {/* Bulk Processing Explanation */}
          {zapierWebhookUrl.trim() && (
            <div className="bg-green-50 border border-green-200 rounded-lg p-4">
              <h4 className="text-sm font-semibold text-green-800 mb-2">✅ How Bulk Lead Export Works</h4>
              <div className="text-sm text-green-700 space-y-1">
                <p><strong>Single Lead:</strong> Creates 1 HubSpot contact directly</p>
                <p><strong>Multiple Leads:</strong> Sends array to Zapier → Code Step processes each → Creates multiple HubSpot contacts</p>
                <p className="text-xs text-green-600 pt-1">
                  💡 Make sure your Zapier workflow includes the Code Step for bulk processing (see documentation link above)
                </p>
              </div>
            </div>
          )}

          <div className="bg-blue-50 border border-blue-200 rounded-md p-4">
            <h4 className="text-sm font-medium text-blue-800 mb-2">HubSpot Field Mapping</h4>
            <div className="text-xs text-blue-700 space-y-1">
              <div><strong>First Name:</strong> Hiring manager first name</div>
              <div><strong>Last Name:</strong> Hiring manager last name</div>
              <div><strong>Email:</strong> Hiring manager email address (required)</div>
              <div><strong>Company Name:</strong> Organization name</div>
              <div><strong>LinkedIn URL:</strong> Hiring manager LinkedIn profile URL</div>
              <div><strong>City:</strong> Job location city</div>
              <div><strong>State/Region Code:</strong> Job location state</div>
              <div><strong>Country/Region:</strong> Defaults to "United States"</div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );

  const openLeadModal = (lead) => {
    setSelectedLead(lead);
    setShowLeadModal(true);
  };

  const closeLeadModal = () => {
    setSelectedLead(null);
    setShowLeadModal(false);
  };

  const renderLeadDetailsModal = () => {
    if (!selectedLead) return null;

    return (
      <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
        <div className="relative top-20 mx-auto p-5 border w-11/12 md:w-3/4 lg:w-1/2 shadow-lg rounded-md bg-white">
          {/* Modal Header */}
          <div className="flex items-center justify-between pb-3 border-b">
            <div>
              <h3 className="text-lg font-semibold text-gray-900">{selectedLead.job_title}</h3>
              <p className="text-sm text-gray-600">{selectedLead.organization}</p>
            </div>
            <button
              onClick={closeLeadModal}
              className="text-gray-400 hover:text-gray-600"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Modal Content */}
          <div className="mt-4 max-h-96 overflow-y-auto">
            {/* Job Description Section */}
            {selectedLead.job_description_text && (
              <div className="mb-6">
                <h4 className="text-md font-semibold text-gray-800 mb-2">Job Description</h4>
                <div className="bg-gray-50 p-3 rounded-md text-sm text-gray-700 whitespace-pre-wrap">
                  {selectedLead.job_description_text}
                </div>
              </div>
            )}

            {/* Hiring Manager Info */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <div>
                <h4 className="text-md font-semibold text-gray-800 mb-2">Hiring Manager</h4>
                <div className="space-y-1 text-sm">
                  <p><span className="font-medium">Name:</span> {selectedLead.ai_hiring_manager_name || selectedLead.li_hiring_manager_name || 'N/A'}</p>
                  {selectedLead.li_hiring_manager_title && (
                    <p><span className="font-medium">Title:</span> {selectedLead.li_hiring_manager_title}</p>
                  )}
                  {selectedLead.ai_hiring_manager_email_address && (
                    <p><span className="font-medium">Email:</span>
                      <a href={`mailto:${selectedLead.ai_hiring_manager_email_address}`} className="text-blue-600 hover:text-blue-800 ml-1">
                        {selectedLead.ai_hiring_manager_email_address}
                      </a>
                    </p>
                  )}
                  {selectedLead.li_hiring_manager_url && (
                    <p><span className="font-medium">LinkedIn:</span>
                      <a href={selectedLead.li_hiring_manager_url} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 ml-1">
                        View Profile
                      </a>
                    </p>
                  )}
                </div>
              </div>

              <div>
                <h4 className="text-md font-semibold text-gray-800 mb-2">Company Details</h4>
                <div className="space-y-1 text-sm">
                  <p><span className="font-medium">Industry:</span> {selectedLead.linkedin_org_industry || 'N/A'}</p>
                  <p><span className="font-medium">Size:</span> {selectedLead.linkedin_org_employees ? `${selectedLead.linkedin_org_employees} employees` : 'N/A'}</p>
                  {selectedLead.linkedin_org_headquarters && (
                    <p><span className="font-medium">HQ:</span> {selectedLead.linkedin_org_headquarters}</p>
                  )}
                  {selectedLead.linkedin_org_type && (
                    <p><span className="font-medium">Type:</span> {selectedLead.linkedin_org_type}</p>
                  )}
                  {selectedLead.organization_url && (
                    <p><span className="font-medium">Website:</span>
                      <a href={selectedLead.organization_url} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 ml-1">
                        Visit Website
                      </a>
                    </p>
                  )}
                </div>
              </div>
            </div>

            {/* Job Details */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <div>
                <h4 className="text-md font-semibold text-gray-800 mb-2">Job Details</h4>
                <div className="space-y-1 text-sm">
                  {selectedLead.ai_experience_level && (
                    <p><span className="font-medium">Experience:</span> {selectedLead.ai_experience_level}</p>
                  )}
                  {selectedLead.ai_work_arrangement && (
                    <p><span className="font-medium">Work Type:</span> {selectedLead.ai_work_arrangement}</p>
                  )}
                  {selectedLead.locations_derived && selectedLead.locations_derived.length > 0 && (
                    <p><span className="font-medium">Location:</span> {selectedLead.locations_derived.join(', ')}</p>
                  )}
                  {selectedLead.remote_derived && (
                    <p><span className="font-medium">Remote:</span> Yes</p>
                  )}
                  {selectedLead.job_url && (
                    <p><span className="font-medium">Job Post:</span>
                      <a href={selectedLead.job_url} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 ml-1">
                        View Original
                      </a>
                    </p>
                  )}
                </div>
              </div>

              <div>
                <h4 className="text-md font-semibold text-gray-800 mb-2">Compensation</h4>
                <div className="space-y-1 text-sm">
                  {selectedLead.ai_salary_minvalue && selectedLead.ai_salary_maxvalue ? (
                    <p><span className="font-medium">Range:</span>
                      {selectedLead.ai_salary_currency || '$'}{selectedLead.ai_salary_minvalue?.toLocaleString()} -
                      {selectedLead.ai_salary_currency || '$'}{selectedLead.ai_salary_maxvalue?.toLocaleString()}
                      {selectedLead.ai_salary_unittext && ` ${selectedLead.ai_salary_unittext}`}
                    </p>
                  ) : selectedLead.ai_salary_maxvalue ? (
                    <p><span className="font-medium">Up to:</span>
                      {selectedLead.ai_salary_currency || '$'}{selectedLead.ai_salary_maxvalue?.toLocaleString()}
                      {selectedLead.ai_salary_unittext && ` ${selectedLead.ai_salary_unittext}`}
                    </p>
                  ) : selectedLead.ai_salary_value ? (
                    <p><span className="font-medium">Salary:</span>
                      {selectedLead.ai_salary_currency || '$'}{selectedLead.ai_salary_value?.toLocaleString()}
                      {selectedLead.ai_salary_unittext && ` ${selectedLead.ai_salary_unittext}`}
                    </p>
                  ) : (
                    <p><span className="font-medium">Salary:</span> Not specified</p>
                  )}
                  {selectedLead.ai_visa_sponsorship && (
                    <p><span className="font-medium">Visa Sponsorship:</span> Available</p>
                  )}
                </div>
              </div>
            </div>

            {/* Skills and Lead Score */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <h4 className="text-md font-semibold text-gray-800 mb-2">Key Skills</h4>
                {selectedLead.ai_key_skills && selectedLead.ai_key_skills.length > 0 ? (
                  <div className="flex flex-wrap gap-1">
                    {selectedLead.ai_key_skills.map((skill, index) => (
                      <span key={index} className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full">
                        {skill}
                      </span>
                    ))}
                  </div>
                ) : (
                  <p className="text-sm text-gray-500">No skills specified</p>
                )}
              </div>

              <div>
                <h4 className="text-md font-semibold text-gray-800 mb-2">Lead Score</h4>
                <div className="flex items-center space-x-2">
                  <span className={`inline-flex px-3 py-1 text-sm font-semibold rounded-full ${
                    (selectedLead.lead_score || 0) >= 70 ? 'bg-green-100 text-green-800' :
                    (selectedLead.lead_score || 0) >= 40 ? 'bg-yellow-100 text-yellow-800' :
                    'bg-red-100 text-red-800'
                  }`}>
                    {selectedLead.lead_score || 0}/100
                  </span>
                  <span className="text-xs text-gray-500">
                    Based on contact info, company data, and job details
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Modal Footer */}
          <div className="flex items-center justify-end pt-3 border-t mt-4 space-x-2">
            {selectedLead.job_description_text && (
              <button
                onClick={() => {
                  navigator.clipboard.writeText(selectedLead.job_description_text);
                  // Could add a toast notification here
                }}
                className="px-4 py-2 text-sm bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md"
              >
                Copy Description
              </button>
            )}
            {selectedLead.ai_hiring_manager_email_address && (
              <a
                href={`mailto:${selectedLead.ai_hiring_manager_email_address}`}
                className="px-4 py-2 text-sm bg-blue-600 hover:bg-blue-700 text-white rounded-md"
              >
                Send Email
              </a>
            )}
            <button
              onClick={closeLeadModal}
              className="px-4 py-2 text-sm bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderSearchHistory = () => {
    return (
      <div className="space-y-6">
        {/* HubSpot Export Setup Notice */}
        {!zapierWebhookUrl.trim() && (
          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4">
            <div className="flex">
              <div className="flex-shrink-0">
                <svg className="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="ml-3">
                <h3 className="text-sm font-medium text-yellow-800">
                  HubSpot Export Not Configured
                </h3>
                <div className="mt-2 text-sm text-yellow-700">
                  <p>
                    To export leads to HubSpot, you need to configure your Zapier webhook URL first.
                  </p>
                  <button
                    onClick={() => handleTabChange('api-settings')}
                    className="mt-2 inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded text-yellow-800 bg-yellow-100 hover:bg-yellow-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500"
                  >
                    <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                    Go to Settings to Configure
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Search History Section */}
        <div className="bg-white shadow rounded-lg">
          <div className="px-6 py-4 border-b border-gray-200">
            <h3 className="text-lg font-medium text-gray-900">Search History</h3>
            <p className="mt-1 text-sm text-gray-600">
              View past searches and their results
              {zapierWebhookUrl.trim() && <span className="text-green-600 font-medium"> • HubSpot export enabled</span>}
            </p>
          </div>

          <div className="p-6">
            {isLoadingHistory ? (
              <div className="text-center py-4">
                <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                <p className="mt-2 text-sm text-gray-600">Loading search history...</p>
              </div>
            ) : searchHistory.length === 0 ? (
              <div className="text-center py-8 text-gray-500">
                <p>No searches found. Run your first search to see history here.</p>
              </div>
            ) : (
              <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
                <table className="min-w-full divide-y divide-gray-300">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Search Name
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Created
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Runs
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Total Leads
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Total Cost
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Last Run
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Status
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {searchHistory.map((search, index) => (
                      <tr key={search.search_id} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                          {search.search_name}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {new Date(search.created_at).toLocaleDateString()}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {search.total_runs}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {search.total_leads_generated}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          ${(search.total_cost_usd || 0).toFixed(4)}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {search.last_run_at ? new Date(search.last_run_at).toLocaleDateString() : 'Never'}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                            search.last_run_status === 'completed' ? 'bg-green-100 text-green-800' :
                            search.last_run_status === 'failed' ? 'bg-red-100 text-red-800' :
                            search.last_run_status === 'running' ? 'bg-yellow-100 text-yellow-800' :
                            'bg-gray-100 text-gray-800'
                          }`}>
                            {search.last_run_status || 'No runs'}
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          <button
                            onClick={() => {
                              setSelectedSearchId(search.search_id);
                              fetchLeads(search.search_id, 0, searchFilters);
                            }}
                            className="text-blue-600 hover:text-blue-900 mr-2"
                          >
                            View Leads
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>

        {/* Leads Section */}
        <div className="bg-white shadow rounded-lg">
          <div className="px-6 py-4 border-b border-gray-200">
            <div className="flex justify-between items-center">
              <div>
                <h3 className="text-lg font-medium text-gray-900">Hiring Manager Leads</h3>
                <p className="mt-1 text-sm text-gray-600">
                  {selectedSearchId ? 'Showing leads from selected search' : 'Showing all leads from database'}
                  {leadsPagination.total > 0 && ` (${leadsPagination.total} total)`}
                </p>
              </div>
              {selectedSearchId && (
                <button
                  onClick={() => {
                    setSelectedSearchId(null);
                    fetchLeads(null, 0, searchFilters);
                  }}
                  className="text-sm text-blue-600 hover:text-blue-900"
                >
                  Show All Leads
                </button>
              )}
            </div>
          </div>

          {/* Search and Filter Controls */}
          <div className="px-6 py-4 bg-gray-50 border-b border-gray-200">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              {/* Global Search */}
              <div className="lg:col-span-2">
                <label className="block text-xs font-medium text-gray-700 mb-1">Search</label>
                <input
                  type="text"
                  value={searchFilters.search}
                  onChange={(e) => handleFilterChange('search', e.target.value)}
                  placeholder="Search jobs, companies, hiring managers..."
                  className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              {/* Industry Filter */}
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">Industry</label>
                <select
                  value={searchFilters.industry}
                  onChange={(e) => handleFilterChange('industry', e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">All Industries</option>
                  {uniqueIndustries.map((industry) => (
                    <option key={industry} value={industry}>
                      {industry}
                    </option>
                  ))}
                </select>
              </div>

              {/* Email Filter */}
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">Contact Type</label>
                <select
                  value={searchFilters.hasEmail}
                  onChange={(e) => handleFilterChange('hasEmail', e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">All Leads</option>
                  <option value="true">Has Email</option>
                  <option value="false">No Email</option>
                </select>
              </div>
            </div>

            {/* Second Row - Lead Score and Actions */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-4">
              {/* Min Score */}
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">Min Score</label>
                <input
                  type="number"
                  value={searchFilters.minScore}
                  onChange={(e) => handleFilterChange('minScore', e.target.value)}
                  placeholder="0"
                  min="0"
                  max="100"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              {/* Max Score */}
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">Max Score</label>
                <input
                  type="number"
                  value={searchFilters.maxScore}
                  onChange={(e) => handleFilterChange('maxScore', e.target.value)}
                  placeholder="100"
                  min="0"
                  max="100"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              {/* Sort Options */}
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">Sort By</label>
                <select
                  value={searchFilters.sortBy}
                  onChange={(e) => handleSortChange(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="created_at">Date Added</option>
                  <option value="lead_score">Lead Score</option>
                  <option value="hubspot_exported_at">HubSpot Export Status</option>
                  <option value="organization">Company Name</option>
                  <option value="job_title">Job Title</option>
                </select>
              </div>

              {/* Clear Filters Button */}
              <div className="flex items-end">
                <button
                  onClick={clearFilters}
                  className="w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  Clear Filters
                </button>
              </div>
            </div>

            {/* Active Filters Display */}
            {(searchFilters.search || searchFilters.industry || searchFilters.minScore || searchFilters.maxScore || searchFilters.hasEmail !== '') && (
              <div className="mt-3 flex flex-wrap gap-2">
                <span className="text-xs text-gray-500">Active filters:</span>
                {searchFilters.search && (
                  <span className="inline-flex items-center px-2 py-1 rounded-md text-xs font-medium bg-blue-100 text-blue-800">
                    Search: {searchFilters.search}
                  </span>
                )}
                {searchFilters.industry && (
                  <span className="inline-flex items-center px-2 py-1 rounded-md text-xs font-medium bg-green-100 text-green-800">
                    Industry: {searchFilters.industry}
                  </span>
                )}
                {(searchFilters.minScore || searchFilters.maxScore) && (
                  <span className="inline-flex items-center px-2 py-1 rounded-md text-xs font-medium bg-yellow-100 text-yellow-800">
                    Score: {searchFilters.minScore || 0}-{searchFilters.maxScore || 100}
                  </span>
                )}
                {searchFilters.hasEmail === 'true' && (
                  <span className="inline-flex items-center px-2 py-1 rounded-md text-xs font-medium bg-purple-100 text-purple-800">
                    Has Email
                  </span>
                )}
                {searchFilters.hasEmail === 'false' && (
                  <span className="inline-flex items-center px-2 py-1 rounded-md text-xs font-medium bg-red-100 text-red-800">
                    No Email
                  </span>
                )}
              </div>
            )}
          </div>


          <div className="p-6">
            {isLoadingLeads ? (
              <div className="text-center py-4">
                <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                <p className="mt-2 text-sm text-gray-600">Loading leads...</p>
              </div>
            ) : leads.length === 0 ? (
              <div className="text-center py-8 text-gray-500">
                <p>No leads found. Run a search to generate leads.</p>
              </div>
            ) : (
              <>
                {/* HubSpot Export Instructions */}
                {zapierWebhookUrl.trim() && (
                  <div className="mb-4 bg-blue-50 border border-blue-200 rounded-lg p-4">
                    <div className="flex">
                      <div className="flex-shrink-0">
                        <svg className="h-5 w-5 text-blue-400" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                        </svg>
                      </div>
                      <div className="ml-3 flex-1">
                        <h3 className="text-sm font-medium text-blue-800">
                          How to Export to HubSpot
                        </h3>
                        <div className="mt-2 text-sm text-blue-700">
                          <p>
                            <strong>1.</strong> Check the boxes next to leads you want to export
                            <br />
                            <strong>2.</strong> Click "Export to HubSpot" button that appears at the bottom
                            <br />
                            <strong>3.</strong> Leads will be sent to your Zapier webhook and synced to HubSpot
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-gray-300">
                    <thead className="bg-gray-50">
                      <tr>
                        {zapierWebhookUrl.trim() && (
                          <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                            <input
                              type="checkbox"
                              checked={selectedLeads.size === leads.length && leads.length > 0}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setSelectedLeads(new Set(leads.map(lead => lead.id)));
                                } else {
                                  setSelectedLeads(new Set());
                                }
                              }}
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                            />
                          </th>
                        )}
                        <th
                          className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                          onClick={() => handleSortChange('job_title')}
                        >
                          <div className="flex items-center">
                            Job Title
                            {searchFilters.sortBy === 'job_title' && (
                              <span className="ml-1">
                                {searchFilters.sortOrder === 'asc' ? '↑' : '↓'}
                              </span>
                            )}
                          </div>
                        </th>
                        <th
                          className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                          onClick={() => handleSortChange('organization')}
                        >
                          <div className="flex items-center">
                            Organization
                            {searchFilters.sortBy === 'organization' && (
                              <span className="ml-1">
                                {searchFilters.sortOrder === 'asc' ? '↑' : '↓'}
                              </span>
                            )}
                          </div>
                        </th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Hiring Manager
                        </th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Email
                        </th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          LinkedIn
                        </th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Location
                        </th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Industry
                        </th>
                        <th
                          className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                          onClick={() => handleSortChange('lead_score')}
                        >
                          <div className="flex items-center">
                            Score
                            {searchFilters.sortBy === 'lead_score' && (
                              <span className="ml-1">
                                {searchFilters.sortOrder === 'asc' ? '↑' : '↓'}
                              </span>
                            )}
                          </div>
                        </th>
                        <th
                          className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                          onClick={() => handleSortChange('hubspot_exported_at')}
                        >
                          <div className="flex items-center">
                            HubSpot Export
                            {searchFilters.sortBy === 'hubspot_exported_at' && (
                              <span className="ml-1">
                                {searchFilters.sortOrder === 'asc' ? '↑' : '↓'}
                              </span>
                            )}
                          </div>
                        </th>
                        <th
                          className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                          onClick={() => handleSortChange('created_at')}
                        >
                          <div className="flex items-center">
                            Added
                            {searchFilters.sortBy === 'created_at' && (
                              <span className="ml-1">
                                {searchFilters.sortOrder === 'asc' ? '↑' : '↓'}
                              </span>
                            )}
                          </div>
                        </th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {leads.map((lead, index) => (
                        <tr key={lead.id} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                          {zapierWebhookUrl.trim() && (
                            <td className="px-4 py-4 text-center">
                              <input
                                type="checkbox"
                                checked={selectedLeads.has(lead.id)}
                                onChange={(e) => {
                                  const newSelected = new Set(selectedLeads);
                                  if (e.target.checked) {
                                    newSelected.add(lead.id);
                                  } else {
                                    newSelected.delete(lead.id);
                                  }
                                  setSelectedLeads(newSelected);
                                }}
                                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                              />
                            </td>
                          )}
                          <td className="px-4 py-4 text-sm text-gray-900">
                            <div className="max-w-xs truncate" title={lead.job_title}>
                              {lead.job_title}
                            </div>
                          </td>
                          <td className="px-4 py-4 text-sm text-gray-900">
                            <div className="max-w-xs truncate" title={lead.organization}>
                              {lead.organization}
                            </div>
                          </td>
                          <td className="px-4 py-4 text-sm text-gray-900">
                            {lead.ai_hiring_manager_name || lead.li_hiring_manager_name || 'N/A'}
                          </td>
                          <td className="px-4 py-4 text-sm text-gray-600">
                            {lead.ai_hiring_manager_email_address ? (
                              <a href={`mailto:${lead.ai_hiring_manager_email_address}`} className="text-blue-600 hover:text-blue-900">
                                {lead.ai_hiring_manager_email_address}
                              </a>
                            ) : 'N/A'}
                          </td>
                          <td className="px-4 py-4 text-sm text-gray-600">
                            {lead.li_hiring_manager_url ? (
                              <a href={lead.li_hiring_manager_url} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-900">
                                LinkedIn
                              </a>
                            ) : 'N/A'}
                          </td>
                          <td className="px-4 py-4 text-sm text-gray-600">
                            {lead.locations_derived && lead.locations_derived.length > 0 ?
                              lead.locations_derived.join(', ') : 'N/A'}
                          </td>
                          <td className="px-4 py-4 text-sm text-gray-600">
                            {lead.linkedin_org_industry || 'N/A'}
                          </td>
                          <td className="px-4 py-4 text-sm text-gray-600">
                            <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                              (lead.lead_score || 0) >= 70 ? 'bg-green-100 text-green-800' :
                              (lead.lead_score || 0) >= 40 ? 'bg-yellow-100 text-yellow-800' :
                              'bg-red-100 text-red-800'
                            }`}>
                              {lead.lead_score || 0}
                            </span>
                          </td>
                          <td className="px-4 py-4 text-sm text-gray-600">
                            {lead.hubspot_exported_at ? (
                              <span className="inline-flex items-center px-2 py-1 text-xs font-medium bg-green-100 text-green-800 rounded-full">
                                <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                </svg>
                                {new Date(lead.hubspot_exported_at).toLocaleDateString()}
                              </span>
                            ) : (
                              <span className="inline-flex items-center px-2 py-1 text-xs font-medium bg-gray-100 text-gray-600 rounded-full">
                                <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                  <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                                </svg>
                                Not exported
                              </span>
                            )}
                          </td>
                          <td className="px-4 py-4 text-sm text-gray-500">
                            {new Date(lead.created_at).toLocaleDateString()}
                          </td>
                          <td className="px-4 py-4 whitespace-nowrap text-sm font-medium">
                            <button
                              onClick={() => {
                                setSelectedLead(lead);
                                setShowLeadModal(true);
                              }}
                              className="text-indigo-600 hover:text-indigo-900"
                            >
                              View Details
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Export Controls */}
                {zapierWebhookUrl.trim() && selectedLeads.size > 0 && (
                  <div className="bg-blue-50 border-t border-blue-200 p-4">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-4">
                        <span className="text-sm font-medium text-blue-900">
                          {selectedLeads.size} lead{selectedLeads.size !== 1 ? 's' : ''} selected
                        </span>

                        {/* Progress Bar */}
                        {exportStatus && exportStatus.type === 'progress' && (
                          <div className="flex items-center space-x-2">
                            <div className="w-32 bg-gray-200 rounded-full h-2">
                              <div
                                className="bg-green-600 h-2 rounded-full transition-all duration-300"
                                style={{ width: `${exportStatus.progress}%` }}
                              />
                            </div>
                            <span className="text-xs text-blue-700">{exportStatus.progress}%</span>
                          </div>
                        )}

                        {/* Status Icons and Messages */}
                        {exportStatus && (
                          <div className="flex items-center space-x-2">
                            {exportStatus.type === 'progress' && (
                              <svg className="animate-spin h-4 w-4 text-blue-600" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="m4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                              </svg>
                            )}
                            {exportStatus.type === 'success' && (
                              <svg className="h-4 w-4 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                              </svg>
                            )}
                            {exportStatus.type === 'error' && (
                              <svg className="h-4 w-4 text-red-600" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                              </svg>
                            )}
                            <span className={`text-sm ${
                              exportStatus.type === 'success' ? 'text-green-700' :
                              exportStatus.type === 'error' ? 'text-red-700' : 'text-blue-700'
                            }`}>
                              {exportStatus.message}
                            </span>
                          </div>
                        )}
                      </div>

                      {/* Export Button */}
                      <button
                        onClick={exportSelectedLeads}
                        disabled={selectedLeads.size === 0 || isExporting}
                        className={`px-4 py-2 rounded-md font-medium ${
                          selectedLeads.size === 0 || isExporting
                            ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                            : 'bg-green-600 text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500'
                        }`}
                      >
                        {isExporting ? 'Exporting...' : 'Export to HubSpot'}
                      </button>
                    </div>
                  </div>
                )}

                {/* Pagination */}
                {leadsPagination.total > leadsPagination.limit && (
                  <div className="mt-6 flex items-center justify-between">
                    <div className="text-sm text-gray-700">
                      Showing {leadsPagination.offset + 1} to {Math.min(leadsPagination.offset + leadsPagination.limit, leadsPagination.total)} of {leadsPagination.total} leads
                    </div>
                    <div className="flex space-x-2">
                      <button
                        onClick={() => fetchLeads(selectedSearchId, Math.max(0, leadsPagination.offset - leadsPagination.limit), searchFilters)}
                        disabled={leadsPagination.offset === 0}
                        className={`px-3 py-2 text-sm rounded-md ${
                          leadsPagination.offset === 0
                            ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                            : 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50'
                        }`}
                      >
                        Previous
                      </button>
                      <button
                        onClick={() => fetchLeads(selectedSearchId, leadsPagination.offset + leadsPagination.limit, searchFilters)}
                        disabled={leadsPagination.offset + leadsPagination.limit >= leadsPagination.total}
                        className={`px-3 py-2 text-sm rounded-md ${
                          leadsPagination.offset + leadsPagination.limit >= leadsPagination.total
                            ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                            : 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50'
                        }`}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    );
  };

  // Fetch analytics data
  const fetchAnalyticsData = async () => {
    console.log('🚀 fetchAnalyticsData called with filters:', analyticsFilters);
    setIsLoadingAnalytics(true);
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        console.log('❌ No token found, redirecting to admin');
        navigate('/admin');
        return;
      }

      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
      console.log('🔗 Backend URL:', backendUrl);

      // Build query parameters
      const params = new URLSearchParams();
      if (analyticsFilters.date_from) params.append('date_from', analyticsFilters.date_from);
      if (analyticsFilters.date_to) params.append('date_to', analyticsFilters.date_to);
      if (analyticsFilters.search_id) params.append('search_id', analyticsFilters.search_id);
      if (analyticsFilters.industry) params.append('industry', analyticsFilters.industry);
      params.append('limit', analyticsFilters.limit);

      const fullUrl = `${backendUrl}/api/business-development/company-frequency?${params}`;
      console.log('📡 Making request to:', fullUrl);

      const response = await fetch(fullUrl, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      console.log('📥 Response status:', response.status);
      console.log('📥 Response ok:', response.ok);

      if (response.status === 401) {
        console.log('❌ 401 Unauthorized - Token may be expired');
        // Clear invalid token and redirect to login
        localStorage.removeItem('token');
        navigate('/admin');
        return;
      }

      if (!response.ok) {
        const errorText = await response.text();
        console.log('❌ Response error text:', errorText);
        throw new Error(`Failed to fetch analytics data: ${response.status} ${errorText}`);
      }

      const data = await response.json();
      console.log('✅ Analytics data received:', data);
      setAnalyticsData(data);
    } catch (err) {
      console.log('❌ Error in fetchAnalyticsData:', err);
      setError(`Error fetching analytics: ${err.message}`);
      // Don't set error for auth issues, just redirect
      if (err.message.includes('401')) {
        localStorage.removeItem('token');
        navigate('/admin');
      }
    } finally {
      setIsLoadingAnalytics(false);
    }
  };

  // Scheduled Searches Functions
  const fetchScheduledSearches = async () => {
    setIsLoadingScheduledSearches(true);
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        navigate('/admin');
        return;
      }

      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
      const response = await fetch(`${backendUrl}/api/business-development/scheduled-searches`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setScheduledSearches(data);
      } else {
        throw new Error('Failed to fetch scheduled searches');
      }
    } catch (err) {
      setError(`Error fetching scheduled searches: ${err.message}`);
      if (err.message.includes('401')) {
        localStorage.removeItem('token');
        navigate('/admin');
      }
    } finally {
      setIsLoadingScheduledSearches(false);
    }
  };

  const fetchScheduledSearchesEnabled = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return;

      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
      const response = await fetch(`${backendUrl}/api/business-development/settings/scheduled_searches_enabled`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setScheduledSearchesEnabled(data.value === 'true');
      }
    } catch (err) {
      console.error('Error fetching scheduled searches enabled status:', err);
    }
  };

  const toggleGlobalScheduledSearches = async () => {
    setIsTogglingGlobal(true);
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        navigate('/admin');
        return;
      }

      const newValue = !scheduledSearchesEnabled;
      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
      const response = await fetch(`${backendUrl}/api/business-development/settings/scheduled_searches_enabled`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ value: newValue.toString() })
      });

      if (response.ok) {
        setScheduledSearchesEnabled(newValue);
        setSuccessMessage(`Scheduled searches ${newValue ? 'enabled' : 'disabled'} successfully`);
        setTimeout(() => setSuccessMessage(''), 3000);
      } else {
        throw new Error('Failed to toggle scheduled searches');
      }
    } catch (err) {
      setError(`Error toggling scheduled searches: ${err.message}`);
      setTimeout(() => setError(''), 3000);
    } finally {
      setIsTogglingGlobal(false);
    }
  };

  const toggleScheduledSearch = async (searchId) => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        navigate('/admin');
        return;
      }

      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
      const response = await fetch(`${backendUrl}/api/business-development/scheduled-searches/${searchId}/toggle`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        // Refresh the scheduled searches list
        fetchScheduledSearches();
      } else {
        throw new Error('Failed to toggle search');
      }
    } catch (err) {
      setError(`Error toggling search: ${err.message}`);
      setTimeout(() => setError(''), 3000);
    }
  };

  const runSearchNow = async (searchId) => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        navigate('/admin');
        return;
      }

      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
      const response = await fetch(`${backendUrl}/api/business-development/scheduled-searches/${searchId}/run-now`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setSuccessMessage(`Search completed: Found ${data.leads_found} leads, ${data.new_leads_added} new`);
        setTimeout(() => setSuccessMessage(''), 5000);
        // Refresh the scheduled searches list
        fetchScheduledSearches();
      } else {
        const error = await response.json();
        throw new Error(error.detail || 'Failed to run search');
      }
    } catch (err) {
      setError(`Error running search: ${err.message}`);
      setTimeout(() => setError(''), 5000);
    }
  };

  // Render Scheduled Searches Tab
  const renderScheduledSearches = () => {
    return (
      <div className="space-y-6">
        {/* Global Toggle */}
        <div className={`${scheduledSearchesEnabled ? 'bg-green-50 border-green-200' : 'bg-red-50 border-red-200'} border rounded-lg p-4`}>
          <div className="flex items-center justify-between">
            <div>
              <h3 className={`text-lg font-medium ${scheduledSearchesEnabled ? 'text-green-800' : 'text-red-800'}`}>
                Scheduled Searches: {scheduledSearchesEnabled ? 'ENABLED' : 'DISABLED'}
              </h3>
              <p className={`text-sm ${scheduledSearchesEnabled ? 'text-green-600' : 'text-red-600'}`}>
                {scheduledSearchesEnabled
                  ? 'Searches will run automatically at 6 AM UTC daily'
                  : 'All scheduled searches are paused'
                }
              </p>
            </div>
            <button
              onClick={toggleGlobalScheduledSearches}
              disabled={isTogglingGlobal}
              className={`px-4 py-2 rounded-md font-medium ${
                scheduledSearchesEnabled
                  ? 'bg-red-600 hover:bg-red-700 text-white'
                  : 'bg-green-600 hover:bg-green-700 text-white'
              } disabled:opacity-50`}
            >
              {isTogglingGlobal ? 'Updating...' : (scheduledSearchesEnabled ? 'Disable' : 'Enable')}
            </button>
          </div>
        </div>

        {/* Scheduled Searches List */}
        <div className="bg-white shadow rounded-lg">
          <div className="px-4 py-5 sm:p-6">
            <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4">
              Scheduled Searches
            </h3>

            {isLoadingScheduledSearches ? (
              <div className="text-center py-4">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
                <p className="mt-2 text-sm text-gray-500">Loading scheduled searches...</p>
              </div>
            ) : scheduledSearches.length === 0 ? (
              <div className="text-center py-8 text-gray-500">
                <p>No scheduled searches found.</p>
                <p className="text-sm mt-2">Create searches with scheduling in the Manual Search tab.</p>
              </div>
            ) : (
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Search Name
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Schedule
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Keywords
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Last Run
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Next Run
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Stats
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {scheduledSearches.map((search) => (
                      <tr key={search.id}>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="flex items-center">
                            <div>
                              <div className="text-sm font-medium text-gray-900">
                                {search.search_name}
                              </div>
                              <div className={`text-xs ${search.is_active ? 'text-green-600' : 'text-red-600'}`}>
                                {search.is_active ? 'Active' : 'Inactive'}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          <div>
                            <div className="font-medium capitalize">{search.schedule_type}</div>
                            <div className="text-xs text-gray-500">
                              {search.schedule_time ? `at ${search.schedule_time}` : 'at 09:00'}
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          <div className="max-w-xs truncate">
                            {search.title_search?.join(', ') || 'No keywords'}
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {search.last_run_at ? new Date(search.last_run_at).toLocaleDateString() : 'Never'}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {search.next_run_at ? new Date(search.next_run_at).toLocaleDateString() : 'Not scheduled'}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          <div>
                            <div>{search.total_runs} runs</div>
                            <div className="text-xs">{search.total_leads_generated} leads</div>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium space-x-2">
                          <button
                            onClick={() => toggleScheduledSearch(search.id)}
                            className={`${
                              search.is_active
                                ? 'text-red-600 hover:text-red-900'
                                : 'text-green-600 hover:text-green-900'
                            }`}
                          >
                            {search.is_active ? 'Disable' : 'Enable'}
                          </button>
                          <button
                            onClick={() => runSearchNow(search.id)}
                            className="text-blue-600 hover:text-blue-900"
                            disabled={!scheduledSearchesEnabled}
                          >
                            Run Now
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>

        {/* Instructions */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <h4 className="text-sm font-medium text-blue-800 mb-2">How to Create Scheduled Searches</h4>
          <ol className="text-sm text-blue-700 space-y-1 list-decimal list-inside">
            <li>Go to the "Manual Search" tab</li>
            <li>Configure your search parameters (keywords, location, etc.)</li>
            <li>Set the "Schedule Type" to "Daily" or "Weekly"</li>
            <li>Choose a time and (for weekly) days of the week</li>
            <li>Save the search - it will appear here as a scheduled search</li>
          </ol>
        </div>
      </div>
    );
  };

  // Render Analytics Tab
  const renderAnalytics = () => {
    // Prepare data for bar chart
    const chartData = analyticsData?.companies?.map(item => ({
      company: item.company.length > 20 ? item.company.substring(0, 20) + '...' : item.company,
      fullCompany: item.company,
      count: item.count,
      industry: item.industry
    })) || [];

    return (
      <div className="space-y-6">
        {/* Filters Section */}
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h3 className="text-xl font-semibold mb-4">Analytics Filters</h3>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {/* Date From */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Date From
              </label>
              <input
                type="date"
                value={analyticsFilters.date_from}
                onChange={(e) => setAnalyticsFilters({...analyticsFilters, date_from: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
              />
            </div>

            {/* Date To */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Date To
              </label>
              <input
                type="date"
                value={analyticsFilters.date_to}
                onChange={(e) => setAnalyticsFilters({...analyticsFilters, date_to: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
              />
            </div>

            {/* Search Selection */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Search
              </label>
              <select
                value={analyticsFilters.search_id}
                onChange={(e) => setAnalyticsFilters({...analyticsFilters, search_id: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
              >
                <option value="">All Searches</option>
                {searchHistory && searchHistory.map((search, index) => (
                  <option key={search.id || `search-index-${index}`} value={search.id || ''}>
                    {search.name || 'Unnamed Search'}
                  </option>
                ))}
              </select>
            </div>

            {/* Industry Filter */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Industry
              </label>
              <select
                value={analyticsFilters.industry}
                onChange={(e) => setAnalyticsFilters({...analyticsFilters, industry: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
              >
                <option value="">All Industries</option>
                {INDUSTRY_OPTIONS.filter(i => i).map((industry, index) => (
                  <option key={`industry-${index}`} value={industry}>
                    {industry}
                  </option>
                ))}
              </select>
            </div>

            {/* Limit */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Top N Companies
              </label>
              <select
                value={analyticsFilters.limit}
                onChange={(e) => setAnalyticsFilters({...analyticsFilters, limit: parseInt(e.target.value)})}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
              >
                <option value="10">Top 10</option>
                <option value="20">Top 20</option>
                <option value="30">Top 30</option>
                <option value="50">Top 50</option>
                <option value="100">Top 100</option>
              </select>
            </div>

            {/* Apply Filters Button */}
            <div className="flex items-end">
              <button
                onClick={fetchAnalyticsData}
                disabled={isLoadingAnalytics}
                className="w-full px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors"
              >
                {isLoadingAnalytics ? 'Loading...' : 'Apply Filters'}
              </button>
            </div>
          </div>

          {/* Date Range Display */}
          {analyticsData && (
            <div className="mt-4 text-sm text-gray-600">
              <span className="font-medium">Date Range:</span> {analyticsData.date_range} |
              <span className="font-medium ml-2">Total Leads:</span> {analyticsData.total_leads}
            </div>
          )}
        </div>

        {/* Company Frequency Bar Chart */}
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h3 className="text-xl font-semibold mb-4">Top Companies by Lead Count</h3>

          {isLoadingAnalytics ? (
            <div className="flex justify-center items-center h-96">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600"></div>
            </div>
          ) : chartData.length > 0 ? (
            <ResponsiveContainer width="100%" height={400}>
              <BarChart
                data={chartData}
                margin={{ top: 20, right: 30, left: 20, bottom: 100 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis
                  dataKey="company"
                  angle={-45}
                  textAnchor="end"
                  height={100}
                  interval={0}
                  tick={{ fontSize: 11 }}
                />
                <YAxis
                  label={{ value: 'Number of Leads', angle: -90, position: 'insideLeft' }}
                />
                <Tooltip
                  content={({ active, payload }) => {
                    if (active && payload && payload[0]) {
                      return (
                        <div className="bg-white p-3 border border-gray-300 rounded shadow-lg">
                          <p className="font-semibold text-sm">{payload[0].payload.fullCompany}</p>
                          <p className="text-xs text-gray-600">Industry: {payload[0].payload.industry || 'Unknown'}</p>
                          <p className="text-sm font-medium text-purple-600">Leads: {payload[0].value}</p>
                        </div>
                      );
                    }
                    return null;
                  }}
                />
                <Bar dataKey="count" fill="#9333ea" />
              </BarChart>
            </ResponsiveContainer>
          ) : (
            <div className="text-center py-12 text-gray-500">
              No data available. Apply filters to see analytics.
            </div>
          )}

          {chartData.length > 0 && (
            <div className="mt-4 text-xs text-gray-500 text-center">
              Showing top {chartData.length} companies by lead count
            </div>
          )}
        </div>

        {/* Industry TreeMap Visualization */}
        {analyticsData?.industries && analyticsData.industries.length > 0 && (() => {
          // Generate color palette for industries
          const COLORS = [
            '#8b5cf6', '#ec4899', '#ef4444', '#f59e0b', '#10b981',
            '#06b6d4', '#3b82f6', '#6366f1', '#84cc16', '#f97316',
            '#14b8a6', '#8b5cf6', '#f43f5e', '#a855f7', '#0ea5e9'
          ];

          // Create a custom content renderer for the TreeMap
          const CustomizedContent = (props) => {
            const { root, depth, x, y, width, height, index, name, value, colors } = props;

            // Skip rendering if dimensions are too small
            if (width < 30 || height < 30) return null;

            // Industry level (depth === 1)
            if (depth === 1) {
              const colorIndex = index % COLORS.length;
              return (
                <g>
                  <rect
                    x={x}
                    y={y}
                    width={width}
                    height={height}
                    style={{
                      fill: COLORS[colorIndex],
                      fillOpacity: 0.8,
                      stroke: '#fff',
                      strokeWidth: 2,
                    }}
                  />
                  {width > 50 && height > 40 && (
                    <>
                      <text
                        x={x + width / 2}
                        y={y + height / 2 - 10}
                        textAnchor="middle"
                        fill="#fff"
                        fontSize={Math.min(width / 10, height / 5, 14)}
                        fontWeight="bold"
                      >
                        {name && name.length > 20 ? name.substring(0, 20) + '...' : name}
                      </text>
                      <text
                        x={x + width / 2}
                        y={y + height / 2 + 10}
                        textAnchor="middle"
                        fill="#fff"
                        fontSize={Math.min(width / 12, height / 6, 11)}
                      >
                        {value} leads
                      </text>
                    </>
                  )}
                </g>
              );
            }

            // Company level (depth === 2)
            if (depth === 2) {
              // Get parent industry index to use the same color
              const parentIndex = root.children.findIndex(industry =>
                industry.children && industry.children.some(company => company.name === name)
              );
              const colorIndex = parentIndex % COLORS.length;

              return (
                <g>
                  <rect
                    x={x}
                    y={y}
                    width={width}
                    height={height}
                    style={{
                      fill: COLORS[colorIndex],
                      fillOpacity: 0.6,
                      stroke: '#fff',
                      strokeWidth: 1,
                    }}
                  />
                  {width > 40 && height > 25 && (
                    <text
                      x={x + width / 2}
                      y={y + height / 2}
                      textAnchor="middle"
                      fill="#fff"
                      fontSize={Math.min(width / 8, height / 3, 10)}
                      fontWeight="500"
                    >
                      {name && name.length > 15 ? name.substring(0, 15) + '...' : name}
                    </text>
                  )}
                </g>
              );
            }

            return null;
          };

          return (
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold mb-4">Company Distribution by Industry (TreeMap)</h3>

              <div className="mb-4 text-sm text-gray-600">
                <p>Total Industries: <span className="font-medium">{analyticsData.industries.length}</span></p>
                <p>Date Range: <span className="font-medium">{analyticsData.date_range}</span></p>
                <p>Total Leads: <span className="font-medium">{analyticsData.total_leads}</span></p>
              </div>

              <ResponsiveContainer width="100%" height={500}>
                <Treemap
                  data={analyticsData.industries}
                  dataKey="value"
                  content={<CustomizedContent />}
                >
                  <Tooltip
                    content={({ active, payload }) => {
                      if (active && payload && payload[0]) {
                        const data = payload[0].payload;
                        return (
                          <div className="bg-white p-3 border border-gray-200 rounded shadow-lg">
                            <p className="font-semibold">{data.name}</p>
                            <p className="text-sm text-gray-600">Count: {data.value}</p>
                            {data.industry && (
                              <p className="text-sm text-gray-600">Industry: {data.industry}</p>
                            )}
                          </div>
                        );
                      }
                      return null;
                    }}
                  />
                </Treemap>
              </ResponsiveContainer>

              <div className="mt-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {analyticsData.industries.slice(0, 6).map((industry, index) => {
                  const colorIndex = index % COLORS.length;
                  return (
                    <div key={industry.name || `industry-${index}`} className="border border-gray-200 rounded-lg p-4">
                      <div className="flex justify-between items-start mb-2">
                        <h4 className="font-medium text-gray-900 text-sm flex items-center">
                          <span
                            className="w-3 h-3 rounded-full mr-2"
                            style={{ backgroundColor: COLORS[colorIndex] }}
                          />
                          {industry.name || 'Unknown'}
                        </h4>
                        <span className="text-xs font-semibold text-purple-600">{industry.value || 0} leads</span>
                      </div>
                      <div className="text-xs text-gray-600">
                        {industry.children && industry.children.length > 0 ? (
                          <>Top: {industry.children.slice(0, 2).map(c => c.name).join(', ')}</>
                        ) : (
                          'No companies'
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>

              <div className="mt-4 text-xs text-gray-500">
                <p>💡 <strong>How to read this TreeMap:</strong></p>
                <p className="mt-1">• Each color represents a different industry</p>
                <p className="mt-1">• Larger rectangles = more leads/mentions</p>
                <p className="mt-1">• Companies within the same industry share the same color</p>
                <p className="mt-1">• Hover over areas to see details</p>
              </div>
            </div>
          );
        })()}
      </div>
    );
  };

  return (
    <AdminRouteGuard requiredPermission={ADMIN_SECTIONS.BUSINESS_DEVELOPMENT}>
      <div className="min-h-screen bg-gray-100">
        {/* Header */}
        <div className="bg-white shadow-sm border-b border-gray-200">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center py-4">
              <div className="flex items-center space-x-4">
                <img src={nacmeLogo} alt="NACME" className="h-8 w-auto" />
                <h1 className="text-2xl font-bold text-gray-900">
                  Business Development
                </h1>
              </div>
              <button
                onClick={() => navigate('/admin')}
                className="text-gray-600 hover:text-gray-800 text-sm font-medium"
              >
                ← Back to Admin
              </button>
            </div>
          </div>
        </div>

        {/* Tab Navigation */}
        <div className="bg-white border-b border-gray-200">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <nav className="flex space-x-8">
              <button
                onClick={() => handleTabChange('manual-search')}
                className={`py-4 px-1 border-b-2 font-medium text-sm ${
                  activeTab === 'manual-search'
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                Manual Search
              </button>

              <button
                onClick={() => handleTabChange('cost-tracking')}
                className={`py-4 px-1 border-b-2 font-medium text-sm ${
                  activeTab === 'cost-tracking'
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                Cost Tracking
              </button>

              <button
                onClick={() => handleTabChange('search-history')}
                className={`py-4 px-1 border-b-2 font-medium text-sm ${
                  activeTab === 'search-history'
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                Search History
              </button>

              <button
                onClick={() => handleTabChange('scheduled-searches')}
                className={`py-4 px-1 border-b-2 font-medium text-sm ${
                  activeTab === 'scheduled-searches'
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                Scheduled Searches
              </button>

              <button
                onClick={() => handleTabChange('api-settings')}
                className={`py-4 px-1 border-b-2 font-medium text-sm ${
                  activeTab === 'api-settings'
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                API Settings
              </button>

              <button
                onClick={() => handleTabChange('analytics')}
                className={`py-4 px-1 border-b-2 font-medium text-sm ${
                  activeTab === 'analytics'
                    ? 'border-purple-500 text-purple-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                Analytics
              </button>
            </nav>
          </div>
        </div>

        {/* Main Content */}
        <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
          {/* Error/Success Messages */}
          {error && (
            <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-md">
              <div className="text-sm text-red-700">{error}</div>
            </div>
          )}

          {successMessage && (
            <div className="mb-4 p-4 bg-green-50 border border-green-200 rounded-md">
              <div className="text-sm text-green-700">{successMessage}</div>
            </div>
          )}

          {/* Tab Content */}
          {activeTab === 'manual-search' && renderManualSearch()}
          {activeTab === 'cost-tracking' && renderCostTracking()}
          {activeTab === 'search-history' && renderSearchHistory()}
          {activeTab === 'scheduled-searches' && renderScheduledSearches()}
          {activeTab === 'api-settings' && renderApiSettings()}
          {activeTab === 'analytics' && renderAnalytics()}
        </div>

        {/* Lead Details Modal */}
        {showLeadModal && renderLeadDetailsModal()}
      </div>
    </AdminRouteGuard>
  );
};

export default AdminBusinessDevelopment;